<template>
<div id="app" class="bg">
  <navigation @open-cart="cart"></navigation>
  <b-container fluid id="container" style="overflow:hidden;">
    <b-row style="margin-top:70px;">
    <b-col v-resize:debounce="onResize" :md="isCollapsed ? '12' : orientation === 'horizontal' ? '8' : '8'" id="map-container" :style="{transform: finish === 'framed' ? 'scale(0.95)' : '', marginLeft: centeredAdjustment}" style="transition: all .1s;height:100%;width:100%;">

      <div id="svg-container">
      <svg v-if="overlay || labels" class="mx-auto" version="1.1" id="svg-overlay" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" v-bind:viewBox="'0 0  ' + mapWidth + ' ' + mapHeight" v-bind:style="{width: mapWidth + 'px', height: mapHeight + 'px'}" style="enable-background:new 0 0 450 600;pointer-events:none;position:absolute;z-index:100;" xml:space="preserve">
        <defs>

          <pattern id="pattern" patternUnits="userSpaceOnUse" v-bind:width="mapWidth" v-bind:height="mapHeight">
            <image xlink:href="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 15' width='10' height='15'%3E%3Cpath fill='%239C92AC' fill-opacity='1' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E" x="0" y="0" width="450" height="600" />
          </pattern>
          <mask id="overlay-mask">
            <rect v-bind:width="mapWidth" v-bind:height="mapHeight" y="0" fill="white"></rect>
            <path v-if="overlayShape === 'heart'" v-bind:style="iconTransform" fill="black" width="100" height="100" d="M51.911,16.242C51.152,7.888,45.239,1.827,37.839,1.827c-4.93,0-9.444,2.653-11.984,6.905
            c-2.517-4.307-6.846-6.906-11.697-6.906c-7.399,0-13.313,6.061-14.071,14.415c-0.06,0.369-0.306,2.311,0.442,5.478
            c1.078,4.568,3.568,8.723,7.199,12.013l18.115,16.439l18.426-16.438c3.631-3.291,6.121-7.445,7.199-12.014
            C52.216,18.553,51.97,16.611,51.911,16.242z"/>
            <path v-if="overlayShape === 'smile'" v-bind:style="iconTransform" fill="black" width="100" height="100" d="M246.613,0C110.413,0,0,110.412,0,246.613s110.413,246.611,246.613,246.611s246.611-110.412,246.611-246.611
            S382.812,0,246.613,0z M343.238,128.733c21.128,0,38.256,17.128,38.256,38.256s-17.128,38.256-38.256,38.256
            s-38.256-17.128-38.256-38.256S322.11,128.733,343.238,128.733z M146.495,128.733c21.128,0,38.256,17.128,38.256,38.256
            s-17.128,38.256-38.256,38.256s-38.256-17.128-38.256-38.256S125.367,128.733,146.495,128.733z M247.233,412.917
            c-74.374,0-138.225-45.025-165.805-109.302h48.725c24.021,39.5,67.469,65.885,117.079,65.885s93.058-26.384,117.079-65.885h48.725
            C385.46,367.892,321.608,412.917,247.233,412.917z"/>
            <path v-if="overlayShape === 'circle'" v-bind:style="iconTransform" fill="black" width="100" height="100" d="M409.133,109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736,9.801,259.058,0,219.273,0
            c-39.781,0-76.47,9.801-110.063,29.407c-33.595,19.604-60.192,46.201-79.8,79.796C9.801,142.8,0,179.489,0,219.267
            c0,39.78,9.804,76.463,29.407,110.062c19.607,33.592,46.204,60.189,79.799,79.798c33.597,19.605,70.283,29.407,110.063,29.407
            s76.47-9.802,110.065-29.407c33.593-19.602,60.189-46.206,79.795-79.798c19.603-33.596,29.403-70.284,29.403-110.062
            C438.533,179.485,428.732,142.795,409.133,109.203z"/>
            <path v-if="overlayShape === 'square'" v-bind:style="iconTransform" fill="black" width="100" height="100" d="M1 1h14v14h-14v-14z"/>

            <rect v-if="overlayShape === 'text'" fill="black"  v-bind:width="mapWidth" v-bind:height="bg_height"/>
            <rect v-if="overlayShape === 'none'" fill="black"  v-bind:width="mapWidth" v-bind:height="mapHeight"/>
          </mask>
        </defs>
          <rect mask="url(#overlay-mask)"  v-bind:width="mapWidth" v-bind:height="mapHeight"   y="0" v-bind:fill="bg_color" v-bind:fill-opacity="bg_opacity"></rect>
          <!--<g id="text-group" :transform="'translate(0,' + (mapHeight - (mapHeight - Math.min(140, percentage(mapHeight, 15))) - (textOptions.text_background))/2 + ')'">-->
          <svg id="text-group" v-bind:width="mapWidth" height="100%" :viewBox="'0 0 ' + mapWidth + ' ' + mapHeight">
            <g :transform="'translate(0,'+ text_group_height +')'" style="transform-origin:center;">
          <text v-if="!text_spacing && labels" id="title" v-bind:text-anchor="text_layout" v-bind:x="text_layout === 'middle' ? mapWidth / 2 : text_layout === 'end' ? mapWidth - 15 : 15" v-bind:y="textOptions.title.y" v-bind:fill="text_color" v-bind:style="{fontSize: textOptions.titleFontSize, fontFamily: font_family}">{{text}}</text>
          <text v-if="text_spacing && labels" id="title" textLength='95%' lengthAdjust="spacing" v-bind:text-anchor="text_layout" v-bind:x="text_layout === 'middle' ? mapWidth / 2 : text_layout === 'end' ? mapWidth - 15 : 15" v-bind:y="textOptions.title.y" v-bind:fill="text_color" v-bind:style="{fontSize: textOptions.titleFontSize, fontFamily: font_family}">{{text}}</text>
          <text v-if="labels && showSubtitle" id="subtitle" v-bind:text-anchor="text_layout" v-bind:x="text_layout === 'middle' ? mapWidth / 2 : text_layout === 'end' ? mapWidth - 15 : 15" v-bind:y="textOptions.subtitle.y" v-bind:fill="text_color" v-bind:style="{fontSize: textOptions.subtitleFontSize, fontFamily: font_family}">{{subtitle}}</text>
          <text v-if="labels && showTagline" id="tagline" v-bind:text-anchor="text_layout" v-bind:x="text_layout === 'middle' ? mapWidth / 2 : text_layout === 'end' ? mapWidth - 15 : 15" v-bind:y="textOptions.tagline.y" v-bind:fill="text_color" v-bind:style="{fontSize: textOptions.taglineFontSize, fontFamily: font_family}">{{tagline}}</text>
            </g>
          </svg>
          <!--</g>-->
      </svg>
      </div>

      <div id="test" style="display:none;position:absolute;width:300px;height:300px;margin-left:150px;margin-top:250px;border:5px solid white;z-index:100;pointer-events:none;"></div>

      <mapbox v-resize:debounce="onResize" ref="mapbox"
        v-bind:style="{width: mapWidth + 'px', height: mapHeight + 'px'}"
        access-token="pk.eyJ1IjoiZ2VuZXJhdGl2ZSIsImEiOiJjamd5ajB4OHEyZXVoMnFwMXB1ZTl0ZTFtIn0.kCqRJ5JJUmhjmftGHaYZoA"
        :map-options="{
          style: mapStyle,
          center: center,
          zoom: zoom,
          pitch: 0,
          bearing: 0,
          attributionControl: false,
          preserveDrawingBuffer: true
        }"

        @map-init="mapInitialized"
        @map-load="mapLoaded"
        @map-moveend="mapMoveEnd"
        @map-resize="mapResize"
        style="width:600px;height:900px;box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);margin-bottom:20px;"
        >
      </mapbox>
      <div id="map-bg" v-bind:style="{backgroundColor: landscape_color, backgroundImage: computedPattern, position: 'absolute', top: '0px', zIndex: '-1', width: mapWidth + 'px', height: mapHeight + 'px'}"></div>
      <div id="map-border" v-bind:style="{border: finish === 'framed' ? '20px solid #252525' : 'none', transition: 'all .0s', pointerEvents: 'none', position: 'absolute', top: '0px', zIndex: '101', width: mapWidth + 20 + 'px', height: mapHeight + 20 + 'px', marginLeft: '-10px', marginTop: '-1px', boxShadow: finish === 'framed' ? 'inset rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, inset rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, inset rgba(0, 0, 0, 0.12) 0px 1px 5px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px': 'none'}"></div>
    </b-col>

    <b-col :class="{'bottom-drawer': isCollapsed}" style="z-index:103;background:#F5F5F5;">
      <b-button-group class="d-flex accordion-group" :class="{'button-group-drawer': isCollapsed, 'mb-3': !isCollapsed}">
        <b-button variant="outline-primary" :class="{'active': ui.currentAccordion === 'basics'}" v-b-toggle.basics class="w-100">Basics</b-button>
        <b-button variant="outline-primary" :class="{'active': ui.currentAccordion === 'personalize'}" v-b-toggle.personalize class="w-100">Personalize</b-button>
        <b-button variant="outline-primary" :class="{'active': ui.currentAccordion === 'layout'}" v-b-toggle.layout class="w-100">Layout</b-button>
        <div @click="closeAccordion" v-if="isCollapsed && ui.currentAccordion !== ''" class="drawer-button">
          <span>
            <svg class="drawer-button-out" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" preserveAspectRatio="xMidYMid meet" width="25" height="25" style="margin-left:5px;margin-top:5px;">
              <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"/>
            </svg>
          </span>
        </div>
      </b-button-group>

        <b-collapse v-on:show="setCurrentAccordion('show', 'basics')" v-on:hide="setCurrentAccordion('hide')" title="Basics" id="basics" accordion="options" ref="basics">
          <b-card :class="{'card-body-drawer': isCollapsed && !ui.drawerActive, 'card-body-drawer-active': isCollapsed && ui.drawerActive, 'card-max-height': !isCollapsed}">
          <b-col class="basics" :style="{'display': ui.drawerActive || !isCollapsed ? 'block' : 'none'}">        

          <b-row>
          <h4>Location</h4>

          <vue-simple-suggest
            id="location-input"
            class="w-100"
            v-model="search"
            :list="autoCompleteSearch"
            :min-length="3"   :debounce="300"
            :filter-by-query="false"
            @select="goToLocation"
            ref="suggestComponent"
            placeholder="Type your favorite place in the world"
            display-attribute="text"
            :styles="{'suggestions': isCollapsed === true ? 'simple-suggestion-mobile' : '', 'suggestItem': isCollapsed === true ? 'simple-suggestion-mobile-item' : ''}"
            >
            <div slot="suggestion-item" slot-scope="{suggestion, query}">
              <div class="text" style="max-width:100%;">
                {{suggestion}}
              </div>
            </div>
          </vue-simple-suggest>

          <span v-if="search !== ''" @click="clearSuggestions" class="clear-suggestions">&times;</span>
          <span v-if="search === '' && mapWidth > 570">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" class="search-icon">
              <path transform="scale(0.035)" fill="rgba(0, 0, 0, 0.50)" d="M464.524 412.846l-97.929-97.925c23.6-34.068 35.406-72.047 35.406-113.917 0-27.218-5.284-53.249-15.852-78.087-10.561-24.842-24.838-46.254-42.825-64.241-17.987-17.987-39.396-32.264-64.233-42.826C254.246 5.285 228.217.003 200.999.003c-27.216 0-53.247 5.282-78.085 15.847C98.072 26.412 76.66 40.689 58.673 58.676c-17.989 17.987-32.264 39.403-42.827 64.241C5.282 147.758 0 173.786 0 201.004c0 27.216 5.282 53.238 15.846 78.083 10.562 24.838 24.838 46.247 42.827 64.234 17.987 17.993 39.403 32.264 64.241 42.832 24.841 10.563 50.869 15.844 78.085 15.844 41.879 0 79.852-11.807 113.922-35.405l97.929 97.641c6.852 7.231 15.406 10.849 25.693 10.849 9.897 0 18.467-3.617 25.694-10.849 7.23-7.23 10.848-15.796 10.848-25.693.003-10.082-3.518-18.651-10.561-25.694zM291.363 291.358c-25.029 25.033-55.148 37.549-90.364 37.549-35.21 0-65.329-12.519-90.36-37.549-25.031-25.029-37.546-55.144-37.546-90.36 0-35.21 12.518-65.334 37.546-90.36 25.026-25.032 55.15-37.546 90.36-37.546 35.212 0 65.331 12.519 90.364 37.546 25.033 25.026 37.548 55.15 37.548 90.36 0 35.216-12.519 65.331-37.548 90.36z"/>
            </svg>
          </span>
          </b-row>

          <b-row class="mt-2">
            <b-button :size="'sm'" :variant="'primary'" v-for="(city,i) in sampledCities" @click="jumpToCity(city)" v-bind:key="i" style="margin-bottom:5px;margin-right:5px;font-size:0.80em;">{{city.city}}</b-button>
            <b-button :size="'sm'" :variant="'primary'" @click="jumpToCity('random')" style="margin-bottom:5px;margin-right:5px;font-size:0.80em;">Surprise Me</b-button>
          </b-row>

          <b-row class="mt-2">
          <h4>Styles</h4>
          </b-row>
          <b-row>
          <span v-for="(style,i) in styles" @click="setStyle(style)" v-bind:key="i + '-style'" style="margin-right:4px;margin-bottom:4px;cursor:pointer;"><img v-bind:src="'//instantly-art.firebaseapp.com/static' + style.image" class="style-preview"/></span>
          </b-row>


          <b-row class="mt-2">
            <h4>Customize</h4>
            <!--<b-button block href="#" v-b-toggle.customize variant="primary" class="mt-3">Customize</b-button>-->
          </b-row>
          <!--<b-collapse id="customize" accordion="customize-options" role="tabpanel">-->
          <b-row>
          <b-button :variant="'primary'" @click="randomize" class="btn-block" style="margin-bottom:10px;">Randomize</b-button>
          </b-row>
          <b-row class="mt-2">
          <!--
          Water Color <color-picker :type="'chrome'" v-model="water_color"></color-picker>
          -->
          <b-col cols="6" style="padding:0px;padding-right:5px;">
          <b-button v-b-toggle.water-picker :style="{backgroundColor: water_color}" style="text-shadow:rgb(0, 0, 0) -1px -1px 0px, rgb(0, 0, 0) 1px -1px 0px, rgb(0, 0, 0) -1px 1px 0px, rgb(0, 0, 0) 1px 1px 0px;width:100%;margin-bottom:10px;">Water Color</b-button>
          <b-collapse id="water-picker" style="text-align:center;">
              <colors :width="150" :height="150" v-model="water_color" style="margin-left:auto;margin-right:auto;"></colors>
              Opacity <input type="range" v-model="water_opacity" name="water-opacity" min="0" max="1" step="0.1" />
          </b-collapse>
          </b-col>
          
          <b-col cols="6" style="padding:0px;padding-left:5px;">
          <b-button v-b-toggle.landscape-picker :style="{backgroundColor: landscape_color}" style="text-shadow:rgb(0, 0, 0) -1px -1px 0px, rgb(0, 0, 0) 1px -1px 0px, rgb(0, 0, 0) -1px 1px 0px, rgb(0, 0, 0) 1px 1px 0px;width:100%;margin-bottom:10px;">Landscape Color</b-button>
          <b-collapse id="landscape-picker" style="text-align:center;">
              <colors :width="150" :height="150" v-model="landscape_color" style="margin-left:auto;margin-right:auto;"></colors>
              Opacity <input type="range" v-model="landscape_opacity" name="landscape-opacity" min="0" max="1" step="0.1" />
          </b-collapse>
          </b-col>
            <!--
          <b-popover target="water-popover" title="Water Color">
            <colors :width="150" :height="150" v-model="water_color" style="margin-left:auto;margin-right:auto;"></colors>
          </b-popover>
          -->
          <!--
          <b-button v-b-modal.modal-footer-sm :style="{backgroundColor: water_color}">Water Color</b-button>
          <b-container>
            <b-modal id="modal-footer-sm" size="sm" title="Water Color" ok-only>
              <colors :width="150" :height="150" v-model="water_color" style="margin-left:auto;margin-right:auto;"></colors>
            </b-modal>
          </b-container>
          -->
          </b-row>
          
          <b-row class="mt-2">
            <b-button v-b-toggle.road-picker :style="{backgroundColor: road_color}" style="text-shadow:rgb(0, 0, 0) -1px -1px 0px, rgb(0, 0, 0) 1px -1px 0px, rgb(0, 0, 0) -1px 1px 0px, rgb(0, 0, 0) 1px 1px 0px;width:100%;margin-bottom:10px;">Road Color</b-button>
            <b-collapse id="road-picker" style="text-align:center;margin-left:auto;margin-right:auto;">
                <colors :width="150" :height="150" v-model="road_color" style="margin-left:auto;margin-right:auto;"></colors>
            </b-collapse>
          </b-row>
          <!--
          <b-row class="mt-2">
          <label for="water-opacity">Water Opacity</label> <input type="range" v-model="water_opacity" name="water-opacity" min="0" max="1" step="0.1" />
          </b-row>
          -->

          <!--
          <b-row class="mt-2">
          Landscape Color <color-picker :type="'chrome'" v-model="landscape_color"></color-picker>
          </b-row>
          <b-row class="mt-2">
          <label for="landscape-opacity">Landscape Opacity</label> <input type="range" v-model="landscape_opacity" name="landscape-opacity" min="0" max="1" step="0.1" />
          </b-row>
          <b-row class="mt-2">
          Road Color <color-picker :type="'chrome'" v-model="road_color"></color-picker>
          </b-row>
          -->

          <!--
          <br>
          Building Color <color-picker :type="'chrome'" v-model="building_color"></color-picker>
          <br>
          Nature Color <color-picker :type="'chrome'" v-model="nature_color"></color-picker>
          <br>
          Boundary Color <color-picker :type="'chrome'" v-model="boundary_color"></color-picker>
          <br>
          Label Color <color-picker :type="'chrome'" v-model="label_color"></color-picker>
          -->

          <b-row class="mt-2">
          <input type="checkbox" id="show-subtitle" class="cbx d-none" v-model="showTexture">
          Background Texture <label for="show-subtitle" class="toggle"><span></span></label>
          <div v-if="showTexture" class="patterns w-100" style="max-height:200px;overflow-y:scroll;border-radius:0px;box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);">
            <b-button v-for="(pattern,i) in patterns" @click="pattern_url = pattern" v-bind:key="i" v-bind:style="{backgroundColor: landscape_color, backgroundImage: 'url(//instantly-art.firebaseapp.com/static'+pattern+')', height: '35px', width: '50%', border: '0', borderRadius: '0'}"></b-button>
          </div>
          </b-row>
          <!--</b-collapse>-->

          </b-col>
          </b-card>
          </b-collapse>

        <b-collapse v-on:show="setCurrentAccordion('show', 'personalize')" v-on:hide="setCurrentAccordion('hide')" id="personalize" title="Personalize" accordion="options" ref="personalize">
          <b-card :class="{'card-body-drawer': isCollapsed && !ui.drawerActive, 'card-body-drawer-active': isCollapsed && ui.drawerActive, 'card-max-height': !isCollapsed}">
          <b-col class="personalize" :style="{'display': ui.drawerActive || !isCollapsed ? 'block' : 'none'}">  
              <b-row>
                <b-form-group class="mx-auto w-100">
                  <b-form-radio-group size="md" class="w-100 two-button-options" buttons button-variant="outline-primary" v-model="labels" :options="label_options"/>
                </b-form-group>
              </b-row>

             <div v-show="labels" class="mb-2">
                <b-row style="margin-bottom:10px;">
                  Title
                  <b-form-input v-model="text" type="text" class="text-input"></b-form-input>
                </b-row>
                <b-row class="mb-2">
                <input type="range" v-model="title_font_scale" name="font-scale" min="0.5" max="1.5" step="0.1" style="margin-top:5px;margin-left:auto;margin-right:auto;width:90%;" />
                </b-row>
                <b-row style="margin-bottom:10px;">
                <input type="checkbox" id="show-subtitle" class="cbx d-none" v-model="showSubtitle">
                Subtitle <label for="show-subtitle" class="toggle"><span></span></label>
                <b-form-input v-if="showSubtitle" v-model="subtitle" type="text" class="text-input"></b-form-input>
                </b-row>
                <b-row style="margin-bottom:10px;">
                <input type="checkbox" id="show-tagline" class="cbx d-none" v-model="showTagline">
                Tagline <label for="show-tagline" class="toggle"><span></span></label>
                <b-form-input v-if="showTagline" v-model="tagline" type="text" class="text-input"></b-form-input>
                </b-row>
                <b-row style="margin-bottom:10px;">
                <!--Text Color 
                <color-picker :type="'chrome'" v-model="text_color"></color-picker>
                -->
                  <b-button v-b-toggle.text-picker :style="{backgroundColor: text_color}" style="text-shadow:rgb(0, 0, 0) -1px -1px 0px, rgb(0, 0, 0) 1px -1px 0px, rgb(0, 0, 0) -1px 1px 0px, rgb(0, 0, 0) 1px 1px 0px;width:100%;margin-bottom:10px;">Text Color</b-button>
                  <b-collapse id="text-picker" style="text-align:center;margin-left:auto;margin-right:auto;">
                      <colors :width="150" :height="150" v-model="text_color" style="margin-left:auto;margin-right:auto;"></colors>
                  </b-collapse>
                </b-row>
                <b-row>
                <span class="w-100">Font</span>
                <div id="font-picker" class="w-100"></div>
                </b-row>

                <div class="label-position mx-auto text-center mt-3" style="user-select: none;">
                <span>
                  <svg v-if="labels" @click="text_spacing = !text_spacing" style="cursor:pointer;margin-right:10px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 80" width="50" height="50" preserveAspectRatio="xMidYMid meet">
                    <path :fill="text_spacing ? '#000000' : '#c3c3c3'" transform="translate(0,4) scale(1.15)" d="M56 6H8c-1.104 0-2 .896-2 2v48c0 1.104.896 2 2 2h48c1.104 0 2-.896 2-2V8c0-1.104-.896-2-2-2zm-42 6c0-1.104.896-2 2-2h32c1.104 0 2 .896 2 2v4c0 1.104-.896 2-2 2s-2-.896-2-2v-2H34v24h2c1.104 0 2 .896 2 2s-.896 2-2 2h-8c-1.104 0-2-.896-2-2s.896-2 2-2h2V14H18v2c0 1.104-.896 2-2 2s-2-.896-2-2v-4zm37.414 37.414l-4 4c-.391.391-.902.586-1.414.586s-1.023-.195-1.414-.586c-.781-.781-.781-2.047 0-2.828l.586-.586H18.828l.586.586c.781.781.781 2.047 0 2.828-.39.391-.902.586-1.414.586s-1.024-.195-1.414-.586l-4-4c-.781-.781-.781-2.047 0-2.828l4-4c.78-.781 2.048-.781 2.828 0 .781.781.781 2.047 0 2.828l-.586.586h26.344l-.586-.586c-.781-.781-.781-2.047 0-2.828s2.047-.781 2.828 0l4 4c.781.781.781 2.047 0 2.828z"/>
                  </svg>
                </span>
            <span>
              <svg v-if="labels" @click="text_layout = 'left'" style="cursor:pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" width="50" height="50" preserveAspectRatio="xMidYMid meet">
              <g :fill="text_layout === 'left' ? '#000000' : '#c3c3c3'">
                <path d="M86.6 9.1H95v81.8h-8.4zM29.6 54.2h48.5v26.2H29.6zM5 19.5h73.1v26.2H5z"/>
              </g>
              </svg>
            </span>
            <span>
              <svg v-if="labels" @click="text_layout = 'middle'" style="cursor:pointer;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" width="50" height="50" preserveAspectRatio="xMidYMid meet">
              <g :fill="text_layout === 'middle' ? '#000000' : '#c3c3c3'">
                <path d="M86.6 54.2H54.2v-8.4h20V19.5h-20V9.1h-8.4v10.4h-20v26.3h20v8.4H13.4v26.3h32.4v10.4h8.4V80.5h32.4z"/>
              </g>
              </svg>
            </span>
            <span>
              <svg v-if="labels" @click="text_layout = 'end'" style="cursor:pointer;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" width="50" height="50" preserveAspectRatio="xMidYMid meet">
              <g :fill="text_layout === 'end' ? '#000000' : '#c3c3c3'">
                <path d="M5 9.1h8.4v81.8H5zM21.9 54.2h48.5v26.2H21.9zM21.9 19.5H95v26.2H21.9z"/>
              </g>
              </svg>
            </span>
                </div>
              </div>

              <b-row> 
                <b-form-group class="mx-auto w-100">
                  <b-form-radio-group size="md" class="w-100 two-button-options" buttons button-variant="outline-primary" v-model="overlay" :options="overlay_options"/>
                </b-form-group>
              </b-row>

             <div v-if="overlay" class="mt-2 mb-3">

               <b-row class="mx-auto mb-3">
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'none'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.3729135053112 53.99999999999997 76.08999999999997" width="50" height="72.09"><defs><path d="M192.56 87.37L242.56 87.37L242.56 159.46L192.56 159.46L192.56 87.37Z" id="d3jmUa0AiL"></path><path d="M209.81 153.23L225.31 153.23L225.31 155.98L209.81 155.98L209.81 153.23Z" id="jakOTY8lRX"></path></defs><g><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#jakOTY8lRX" opacity="1" fill="#000000" fill-opacity="1"></use></g></g></svg>
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'text'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.3729135053112 54 76.08999999999997" width="50" height="72.09"><defs><path d="M192.56 87.37L242.56 87.37L242.56 159.46L192.56 159.46L192.56 87.37Z" id="d3jmUa0AiL"></path><path d="M192.56 148.33L242.56 148.33L242.56 159.46L192.56 159.46L192.56 148.33Z" id="d2PhsNqCW"></path><path d="M209.81 153.23L225.31 153.23L225.31 155.98L209.81 155.98L209.81 153.23Z" id="a2ROBbFI2b"></path></defs><g><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#d2PhsNqCW" opacity="1" fill="#000000" fill-opacity="1"></use></g><g><use xlink:href="#a2ROBbFI2b" opacity="1" fill="#ffffff" fill-opacity="1"></use></g></g></svg>
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'circle'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.3729135053112 53.99999999999997 76.08999999999997" width="50" height="72.09"><defs><path d="M192.56 87.37L242.56 87.37L242.56 159.46L192.56 159.46L192.56 87.37Z" id="d3jmUa0AiL"></path><path d="M235.06 124.67C235.06 134.33 227.22 142.17 217.56 142.17C207.91 142.17 200.06 134.33 200.06 124.67C200.06 115.01 207.91 107.17 217.56 107.17C227.22 107.17 235.06 115.01 235.06 124.67Z" id="bo32rViV0"></path></defs><g><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#d3jmUa0AiL" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#bo32rViV0" opacity="1" fill="#000000" fill-opacity="1"></use></g></g></svg>
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'square'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.12291350531122 53.99999999999997 76.08999999999996" width="50" height="72.09"><defs><path d="M192.56 87.12L242.56 87.12L242.56 159.21L192.56 159.21L192.56 87.12Z" id="avvc6KD5"></path><path d="M200.06 106.67L235.06 106.67L235.06 141.67L200.06 141.67L200.06 106.67Z" id="abZdD3ZVi"></path></defs><g><g><use xlink:href="#avvc6KD5" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#avvc6KD5" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#abZdD3ZVi" opacity="1" fill="#000000" fill-opacity="1"></use></g></g></svg>
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'heart'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.12291350531122 53.99999999999997 76.08999999999996" width="50" height="72.09"><defs><path d="M192.56 87.12L242.56 87.12L242.56 159.21L192.56 159.21L192.56 87.12Z" id="avvc6KD5"></path><path d="M226.31 107.23C231.15 107.23 235.06 111.93 235.06 117.73C235.07 133.81 217.56 141.78 217.56 142.23C217.56 142.23 217.56 142.23 217.56 142.23C217.56 141.78 200.06 133.81 200.06 117.73C200.06 111.93 203.98 107.23 208.81 107.23C213.65 107.23 217.56 111.35 217.56 117.15C217.56 111.35 221.48 107.23 226.31 107.23Z" id="av70BbT69"></path></defs><g><g><use xlink:href="#avvc6KD5" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#avvc6KD5" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#av70BbT69" opacity="1" fill="#000000" fill-opacity="1"></use></g></g></svg>
                <svg style="cursor:pointer;margin-right:5px;" @click="overlayShape = 'smile'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="191.56449165402117 86.12291350531122 53.99999999999997 76.08999999999996" width="50" height="72.09"><defs><path d="M192.56 87.12L242.56 87.12L242.56 159.21L192.56 159.21L192.56 87.12Z" id="avvc6KD5"></path><path d="M235.06 123.98C235.06 133.63 227.22 141.48 217.56 141.48C207.91 141.48 200.06 133.63 200.06 123.98C200.06 114.32 207.91 106.48 217.56 106.48C227.22 106.48 235.06 114.32 235.06 123.98Z" id="cee8WbDZ7"></path><path d="M214.67 119.23C214.67 121.02 213.21 122.48 211.42 122.48C209.62 122.48 208.17 121.02 208.17 119.23C208.17 117.43 209.62 115.98 211.42 115.98C213.21 115.98 214.67 117.43 214.67 119.23Z" id="a19amexSmO"></path><path d="M226.17 119.23C226.17 121.02 224.71 122.48 222.92 122.48C221.12 122.48 219.67 121.02 219.67 119.23C219.67 117.43 221.12 115.98 222.92 115.98C224.71 115.98 226.17 117.43 226.17 119.23Z" id="acm26BYz1"></path><path d="M226.1 130.38C221.29 136.64 215.6 136.85 209.03 131.02" id="d32RbGkgfc"></path></defs><g><g><use xlink:href="#avvc6KD5" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#avvc6KD5" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="2" stroke-opacity="1"></use></g></g><g><use xlink:href="#cee8WbDZ7" opacity="1" fill="#000000" fill-opacity="1"></use></g><g><use xlink:href="#a19amexSmO" opacity="1" fill="#ffffff" fill-opacity="1"></use></g><g><use xlink:href="#acm26BYz1" opacity="1" fill="#ffffff" fill-opacity="1"></use></g><g><use xlink:href="#d32RbGkgfc" opacity="1" fill="#000000" fill-opacity="1"></use><g><use xlink:href="#d32RbGkgfc" opacity="1" fill-opacity="0" stroke="#ffffff" stroke-width="2" stroke-opacity="1"></use></g></g></g></svg>
              </b-row>

               <b-row style="margin-bottom:10px;">
                <!--Overlay Color <color-picker :type="'chrome'" v-model="bg_color"></color-picker>-->
                <b-button v-b-toggle.overlay-picker :style="{backgroundColor: bg_color}" style="text-shadow:rgb(0, 0, 0) -1px -1px 0px, rgb(0, 0, 0) 1px -1px 0px, rgb(0, 0, 0) -1px 1px 0px, rgb(0, 0, 0) 1px 1px 0px;width:100%;margin-bottom:10px;">Overlay Color</b-button>
                <b-collapse id="overlay-picker" style="text-align:center;margin-left:auto;margin-right:auto;">
                    <colors :width="150" :height="150" v-model="bg_color" style="margin-left:auto;margin-right:auto;"></colors>
                    Opacity <input type="range" v-model="bg_opacity" name="overlay-opacity" min="0" max="1" step="0.1" />
                </b-collapse>
               </b-row>
               <!--
               <b-row style="margin-bottom:10px;">
                <label for="overlay-opacity">Overlay Opacity</label> <input type="range" v-model="bg_opacity" name="overlay-opacity" min="0" max="1" step="0.1" />
               </b-row>
               -->
              </div>

              </b-col>
              </b-card>
          </b-collapse>

        <b-collapse v-on:show="setCurrentAccordion('show', 'layout')" v-on:hide="setCurrentAccordion('hide')" id="layout" title="Layout" accordion="options" ref="layout">
          <b-card :class="{'card-body-drawer': isCollapsed && !ui.drawerActive, 'card-body-drawer-active': isCollapsed && ui.drawerActive}">
          <b-col class="layout" :style="{'display': ui.drawerActive || !isCollapsed ? 'block' : 'none'}">    
              <b-row>
                <h4>Finish</h4>
                <b-form-group class="mx-auto w-100">
                  <b-form-radio-group size="md" class="w-100 two-button-options" buttons button-variant="outline-primary" v-model="finish" :options="finish_options"/>
                </b-form-group>
                <span v-if="finish === 'paper'" class="mb-2">
                  A museum-quality poster made on thick, durable, matte paper. It's professionally printed on archival, acid-free paper.  
                </span>
                <span v-if="finish === 'framed'">
                  A framed, enhanced matte poster. This museum-quality matte paper will give your design a polished look.
                    <ul class="mt-2" style="font-size:0.80rem;text-align:left;">
                      <li>Alder, Semi-hardwood frame</li>
                      <li>Black in color</li>
                      <li>0.75” thick</li>
                      <li>Acrylite front protector</li>
                      <li>Lightweight</li>
                      <li>Hanging hardware included</li>
                      <li>Made in the USA</li>
                    </ul>  
                </span>
              </b-row>
              <b-row>
                <h4>Orientation</h4>
                <b-form-group class="mx-auto w-100">
                  <b-form-radio-group size="md" class="w-100 two-button-options" buttons button-variant="outline-primary" v-model="orientation" :options="orientation_options"/>
                </b-form-group>
              </b-row>
              <b-row>
                <h4>Size</h4>
                <b-button @click="size = option.value" size="sm" variant="outline-primary" v-bind:class="{'active': size === option.value}" class="btn-block" v-for="(option,i) in size_options" v-bind:key="i">{{option.text}}</b-button>
              </b-row>
            </b-col>
            </b-card>
        </b-collapse>

      <b-button @click="checkout" :size="'lg'" :variant="'warning'" :class="{'checkout-button-fixed': isCollapsed, 'mt-3': !isCollapsed, 'mb-3': !isCollapsed}" class="btn-block"><span style="float:left">USD ${{price + '.00'}}</span> 
      <span v-if="showFreeShipping" style="
    display: none;
    font-size: small;
    margin-top: 5px;
    position: absolute;
    margin-left: -95px;
    margin-right: auto;
    color: black;
">Free Shipping</span>
        <span style="float:right;margin-right:15px;">ADD TO CART 
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="margin-top:8px;margin-left:3px;position:absolute;">
            <path transform="scale(0.05)" d="M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z"/>
          </svg>
        </span>
      </b-button>

      <span v-if="ui.admin_message !== ''" class="mt-3" style="font-weight:bold;">{{ui.admin_message}}</span>

    <canvas id="font-measure" style="display:none;"></canvas>


    
    </b-col>
    </b-row>
<slideout-panel></slideout-panel>

</b-container>
</div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue'
import resize from 'vue-resize-directive'
import { VueColorpicker } from 'vue-pop-colorpicker'
import { random, sampleSize } from 'lodash'
import { FontPicker } from 'font-picker'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import ColorPicker from 'vue-color-picker-wheel'
const randomColor = require('randomcolor')
const tinycolor = require('tinycolor2')
const axios = require('axios')
const generateID = require('nanoid/generate')
import firebase from 'firebase/app'
import 'firebase/firestore'
firebase.initializeApp({
  apiKey: "AIzaSyAqHkrB46oE3qqDW76D4u6wVGqof1PEJx4",
  authDomain: "instantly-art.firebaseapp.com",
  databaseURL: "https://instantly-art.firebaseio.com",
  projectId: "instantly-art",
  storageBucket: "instantly-art.appspot.com",
  messagingSenderId: "173492311891"
})
const db = firebase.firestore()
db.settings({timestampsInSnapshots: true})

export default {
  components: {
    Mapbox,
    'color-picker': VueColorpicker,
    VueSimpleSuggest,
    'colors': ColorPicker
  },
  directives: {
    resize
  },
  data() {
    return {
      ui: {
        admin_message: '',
        drawerActive: false,
        currentAccordion: '',
        windowWidth: 0
      },
      showMap: true,
      accessToken: '',
      style: 'positron',
      ratio: 1,
      center: [-73.97095951798957, 40.751089776899164],
      bounds: [],
      zoom: 11,
      pitch: 0,
      bearing: 0,
      attribution: true,
      map: {},
      bbox: {},
      location: '',
      search: '',
      suggestions: [],
      style_maps: ['positron', 'darkmatter', 'basic', 'streets', 'voyager', 'red-map'],
      mapWidth: 3000,
      mapHeight: 4500,
      finish: 'paper',
      finish_options: [{ text: 'Paper $49', value: 'paper' },{ text: 'Framed $79', value: 'framed' }],
      orientation: 'vertical',
      orientation_options: [{ text: 'Portrait', value: 'vertical' },{ text: 'Landscape', value: 'horizontal' }],
      size: '12x18',
      size_options: [{ text: '12 x 18 in', value: '12x18' }, { text: '18 x 18 in +$35', value: '18x18' }, { text: '18 x 24 in +$40', value: '18x24' }],
      labels: true,
      label_options: [{ text: 'Show Labels', value: true },{ text: 'Hide Labels', value: false }],
      overlay: true,
      overlay_options: [{ text: 'Show Overlay', value: true },{ text: 'Hide Overlay', value: false }],
      overlayShape: 'text',
      text_layout: 'left',
      text_color: '#FFFFFF',
      text: 'NEW YORK CITY',
      subtitle: 'UNITED STATES',
      showSubtitle: false,
      tagline: '40.75°N / 73.97°W',
      showTagline: false,
      text_group_height: 0,
      text_spacing: false,
      title_font_scale: 0.5,
      font_picker: {},
      font_family: 'Comfortaa',
      font_src: 'https://fonts.gstatic.com/s/comfortaa/v27/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf',
      fontStyle: '',
      bg_color: '#000000',
      bg_opacity: 1,
      bg_height: 0,
      water_color: '#0000FF',
      water_opacity: "1",
      landscape_color: '#000000',
      landscape_opacity: 0,
      road_color: '#F5F5F5',
      building_color: '',
      nature_color: '',
      boundary_color: '',
      label_color: 'rgb(0, 0, 0)',
      showTexture: false,
      pattern_url: "/patterns/classy-fabric.png",
      patterns: ["/patterns/3px-tile.png","/patterns/45-degree-fabric-dark.png","/patterns/45-degree-fabric-light.png","/patterns/60-lines.png","/patterns/absurdity.png","/patterns/ag-square.png","/patterns/always-grey.png","/patterns/arabesque.png","/patterns/arches.png","/patterns/argyle.png","/patterns/asfalt-dark.png","/patterns/asfalt-light.png","/patterns/assault.png","/patterns/axiom-pattern.png","/patterns/az-subtle.png","/patterns/back-pattern.png","/patterns/basketball.png","/patterns/batthern.png","/patterns/bedge-grunge.png","/patterns/beige-paper.png","/patterns/billie-holiday.png","/patterns/binding-dark.png","/patterns/binding-light.png","/patterns/black-felt.png","/patterns/black-linen.png","/patterns/black-linen-2.png","/patterns/black-mamba.png","/patterns/black-orchid.png","/patterns/black-paper.png","/patterns/black-scales.png","/patterns/black-thread.png","/patterns/black-thread-light.png","/patterns/black-twill.png","/patterns/blizzard.png","/patterns/blu-stripes.png","/patterns/bo-play.png","/patterns/brick-wall.png","/patterns/brick-wall-dark.png","/patterns/bright-squares.png","/patterns/brilliant.png","/patterns/broken-noise.png","/patterns/brushed-alum.png","/patterns/brushed-alum-dark.png","/patterns/buried.png","/patterns/candyhole.png","/patterns/carbon-fibre.png","/patterns/carbon-fibre-big.png","/patterns/carbon-fibre-v2.png","/patterns/cardboard.png","/patterns/cardboard-flat.png","/patterns/cartographer.png","/patterns/checkered-light-emboss.png","/patterns/checkered-pattern.png","/patterns/church.png","/patterns/circles.png","/patterns/classy-fabric.png","/patterns/clean-gray-paper.png","/patterns/clean-textile.png","/patterns/climpek.png","/patterns/cloth-alike.png","/patterns/concrete-wall.png","/patterns/concrete-wall-2.png","/patterns/concrete-wall-3.png","/patterns/connected.png","/patterns/corrugation.png","/patterns/cream-dust.png","/patterns/cream-paper.png","/patterns/cream-pixels.png","/patterns/crisp-paper-ruffles.png","/patterns/crissxcross.png","/patterns/cross-scratches.png","/patterns/cross-stripes.png","/patterns/crossword.png","/patterns/cubes.png","/patterns/cutcube.png","/patterns/dark-brick-wall.png","/patterns/dark-circles.png","/patterns/dark-denim.png","/patterns/dark-denim-3.png","/patterns/dark-dot.png","/patterns/dark-dotted-2.png","/patterns/dark-exa.png","/patterns/dark-fish-skin.png","/patterns/dark-geometric.png","/patterns/dark-leather.png","/patterns/dark-matter.png","/patterns/dark-mosaic.png","/patterns/dark-stripes.png","/patterns/dark-stripes-light.png","/patterns/dark-tire.png","/patterns/dark-wall.png","/patterns/dark-wood.png","/patterns/darth-stripe.png","/patterns/debut-dark.png","/patterns/debut-light.png","/patterns/diagmonds.png","/patterns/diagmonds-light.png","/patterns/diagonal-noise.png","/patterns/diagonal-striped-brick.png","/patterns/diagonal-waves.png","/patterns/diagonales-decalees.png","/patterns/diamond-eyes.png","/patterns/diamond-upholstery.png","/patterns/diamonds-are-forever.png","/patterns/dimension.png","/patterns/dirty-old-black-shirt.png","/patterns/dotnoise-light-grey.png","/patterns/double-lined.png","/patterns/dust.png","/patterns/ecailles.png","/patterns/egg-shell.png","/patterns/elastoplast.png","/patterns/elegant-grid.png","/patterns/embossed-paper.png","/patterns/escheresque.png","/patterns/escheresque-dark.png","/patterns/exclusive-paper.png","/patterns/fabric-plaid.png","/patterns/fabric-1-dark.png","/patterns/fabric-1-light.png","/patterns/fabric-of-squares.png","/patterns/fake-brick.png","/patterns/fake-luxury.png","/patterns/fancy-deboss.png","/patterns/farmer.png","/patterns/felt.png","/patterns/first-aid-kit.png","/patterns/flower-trail.png","/patterns/flowers.png","/patterns/foggy-birds.png","/patterns/food.png","/patterns/football-no-lines.png","/patterns/french-stucco.png","/patterns/fresh-snow.png","/patterns/gold-scale.png","/patterns/gplay.png","/patterns/gradient-squares.png","/patterns/graphcoders-lil-fiber.png","/patterns/graphy-dark.png","/patterns/graphy.png","/patterns/gravel.png","/patterns/gray-floral.png","/patterns/gray-lines.png","/patterns/gray-sand.png","/patterns/green-cup.png","/patterns/green-dust-and-scratches.png","/patterns/green-fibers.png","/patterns/green-gobbler.png","/patterns/grey-jean.png","/patterns/grey-sandbag.png","/patterns/grey-washed-wall.png","/patterns/greyzz.png","/patterns/grid.png","/patterns/grid-me.png","/patterns/grid-noise.png","/patterns/grilled-noise.png","/patterns/groovepaper.png","/patterns/grunge-wall.png","/patterns/gun-metal.png","/patterns/handmade-paper.png","/patterns/hexabump.png","/patterns/hexellence.png","/patterns/hixs-evolution.png","/patterns/hoffman.png","/patterns/honey-im-subtle.png","/patterns/ice-age.png","/patterns/inflicted.png","/patterns/inspiration-geometry.png","/patterns/iron-grip.png","/patterns/kinda-jean.png","/patterns/knitted-netting.png","/patterns/knitted-sweater.png","/patterns/kuji.png","/patterns/large-leather.png","/patterns/leather.png","/patterns/light-aluminum.png","/patterns/light-gray.png","/patterns/light-grey-floral-motif.png","/patterns/light-honeycomb.png","/patterns/light-honeycomb-dark.png","/patterns/light-mesh.png","/patterns/light-paper-fibers.png","/patterns/light-sketch.png","/patterns/light-toast.png","/patterns/light-wool.png","/patterns/lined-paper.png","/patterns/lined-paper-2.png","/patterns/little-knobs.png","/patterns/little-pluses.png","/patterns/little-triangles.png","/patterns/low-contrast-linen.png","/patterns/lyonnette.png","/patterns/maze-black.png","/patterns/maze-white.png","/patterns/mbossed.png","/patterns/medic-packaging-foil.png","/patterns/merely-cubed.png","/patterns/micro-carbon.png","/patterns/mirrored-squares.png","/patterns/mocha-grunge.png","/patterns/mooning.png","/patterns/moulin.png","/patterns/my-little-plaid-dark.png","/patterns/my-little-plaid.png","/patterns/nami.png","/patterns/nasty-fabric.png","/patterns/natural-paper.png","/patterns/navy.png","/patterns/nice-snow.png","/patterns/nistri.png","/patterns/noise-lines.png","/patterns/noise-pattern-with-subtle-cross-lines.png","/patterns/noisy.png","/patterns/noisy-grid.png","/patterns/noisy-net.png","/patterns/norwegian-rose.png","/patterns/notebook.png","/patterns/notebook-dark.png","/patterns/office.png","/patterns/old-husks.png","/patterns/old-map.png","/patterns/old-mathematics.png","/patterns/old-moon.png","/patterns/old-wall.png","/patterns/otis-redding.png","/patterns/outlets.png","/patterns/p1.png","/patterns/p2.png","/patterns/p4.png","/patterns/p5.png","/patterns/p6.png","/patterns/padded.png","/patterns/padded-light.png","/patterns/paper.png","/patterns/paper-1.png","/patterns/paper-2.png","/patterns/paper-3.png","/patterns/paper-fibers.png","/patterns/paven.png","/patterns/perforated-white-leather.png","/patterns/pineapple-cut.png","/patterns/pinstripe-dark.png","/patterns/pinstripe-light.png","/patterns/pinstriped-suit.png","/patterns/pixel-weave.png","/patterns/polaroid.png","/patterns/polonez-pattern.png","/patterns/polyester-lite.png","/patterns/pool-table.png","/patterns/project-paper.png","/patterns/ps-neutral.png","/patterns/psychedelic.png","/patterns/purty-wood.png","/patterns/pw-pattern.png","/patterns/pyramid.png","/patterns/quilt.png","/patterns/random-grey-variations.png","/patterns/ravenna.png","/patterns/real-carbon-fibre.png","/patterns/rebel.png","/patterns/redox-01.png","/patterns/redox-02.png","/patterns/reticular-tissue.png","/patterns/retina-dust.png","/patterns/retina-wood.png","/patterns/retro-intro.png","/patterns/rice-paper.png","/patterns/rice-paper-2.png","/patterns/rice-paper-3.png","/patterns/robots.png","/patterns/rocky-wall.png","/patterns/rough-cloth.png","/patterns/rough-cloth-light.png","/patterns/rough-diagonal.png","/patterns/rubber-grip.png","/patterns/sandpaper.png","/patterns/satin-weave.png","/patterns/scribble-light.png","/patterns/shattered.png","/patterns/shattered-dark.png","/patterns/shine-caro.png","/patterns/shine-dotted.png","/patterns/shley-tree-1.png","/patterns/shley-tree-2.png","/patterns/silver-scales.png","/patterns/simple-dashed.png","/patterns/simple-horizontal-light.png","/patterns/skeletal-weave.png","/patterns/skewed-print.png","/patterns/skin-side-up.png","/patterns/skulls.png","/patterns/slash-it.png","/patterns/small-crackle-bright.png","/patterns/small-crosses.png","/patterns/smooth-wall-dark.png","/patterns/smooth-wall-light.png","/patterns/sneaker-mesh-fabric.png","/patterns/snow.png","/patterns/soft-circle-scales.png","/patterns/soft-kill.png","/patterns/soft-pad.png","/patterns/soft-wallpaper.png","/patterns/solid.png","/patterns/sos.png","/patterns/sprinkles.png","/patterns/squairy.png","/patterns/squared-metal.png","/patterns/squares.png","/patterns/stacked-circles.png","/patterns/stardust.png","/patterns/starring.png","/patterns/stitched-wool.png","/patterns/strange-bullseyes.png","/patterns/straws.png","/patterns/stressed-linen.png","/patterns/stucco.png","/patterns/subtle-carbon.png","/patterns/subtle-dark-vertical.png","/patterns/subtle-dots.png","/patterns/subtle-freckles.png","/patterns/subtle-grey.png","/patterns/subtle-grunge.png","/patterns/subtle-stripes.png","/patterns/subtle-surface.png","/patterns/subtle-white-feathers.png","/patterns/subtle-zebra-3d.png","/patterns/subtlenet.png","/patterns/swirl.png","/patterns/tactile-noise-dark.png","/patterns/tactile-noise-light.png","/patterns/tapestry.png","/patterns/tasky.png","/patterns/tex2res1.png","/patterns/tex2res2.png","/patterns/tex2res3.png","/patterns/tex2res4.png","/patterns/tex2res5.png","/patterns/textured-paper.png","/patterns/textured-stripes.png","/patterns/texturetastic-gray.png","/patterns/ticks.png","/patterns/tileable-wood.png","/patterns/tileable-wood-colored.png","/patterns/tiny-grid.png","/patterns/translucent-fibres.png","/patterns/transparent-square-tiles.png","/patterns/tree-bark.png","/patterns/triangles.png","/patterns/triangles-2.png","/patterns/triangular.png","/patterns/tweed.png","/patterns/twinkle-twinkle.png","/patterns/txture.png","/patterns/type.png","/patterns/use-your-illusion.png","/patterns/vaio.png","/patterns/vertical-cloth.png","/patterns/vichy.png","/patterns/vintage-speckles.png","/patterns/wall-4-light.png","/patterns/washi.png","/patterns/wave-grid.png","/patterns/wavecut.png","/patterns/weave.png","/patterns/wet-snow.png","/patterns/white-bed-sheet.png","/patterns/white-brick-wall.png","/patterns/white-brushed.png","/patterns/white-carbon.png","/patterns/white-carbonfiber.png","/patterns/white-diamond.png","/patterns/white-diamond-dark.png","/patterns/white-leather.png","/patterns/white-linen.png","/patterns/white-paperboard.png","/patterns/white-plaster.png","/patterns/white-sand.png","/patterns/white-texture.png","/patterns/white-tiles.png","/patterns/white-wall.png","/patterns/white-wall-3.png","/patterns/white-wall-3-2.png","/patterns/white-wave.png","/patterns/whitey.png","/patterns/wide-rectangles.png","/patterns/wild-flowers.png","/patterns/wild-oliva.png","/patterns/wine-cork.png","/patterns/wood.png","/patterns/wood-pattern.png","/patterns/worn-dots.png","/patterns/woven.png","/patterns/woven-light.png","/patterns/xv.png","/patterns/zig-zag.png","/patterns/black-lozenge.png"],
      cities: [{"city":"New York City","country":"United States","bbox":[-74.08118952792634,40.751138113884565,-73.85996762721396,40.766623074834456],"center":[-73.97057857757841,40.75888104525933],"zoom":11,"pitch":0,"bearing":0},{"city":"San Francisco","country":"United States","bbox":[-122.47993851761625,37.560702165216355,-122.36896105457437,37.85005874805904],"center":[-122.4244497860945,37.70552166370595],"zoom":11,"pitch":0,"bearing":-20},{"city":"Chicago","country":"United States","bbox":[-87.76284918737187,41.767275390452625,-87.53410311128611,41.99427336485917],"center":[-87.64847614932785,41.880875175681325],"zoom":11,"pitch":0,"bearing":0},{"city":"Miami","country":"United States","bbox":[-80.30807303802663,25.636943722425244,-80.07932696194084,25.911497460174516],"center":[-80.1936999999989,25.774299999997282],"zoom":11,"pitch":0,"bearing":0},{"city":"Los Angeles","country":"United States","bbox":[-118.35560342311712,33.92672289343925,-118.1274830482184,34.178636498254875],"center":[-118.2415432356762,34.05277326660455],"zoom":11,"pitch":0,"bearing":0},{"city":"Boston","country":"United States","bbox":[-71.1080887721518,42.30308622657833,-70.99280281275354,42.41662957859381],"center":[-71.05044579245083,42.35988354922614],"zoom":11,"pitch":0,"bearing":0},{"city":"San Diego","country":"United States","bbox":[-117.19880894073933,32.66255476271749,-117.10930112519239,32.76293358931986],"center":[-117.15405503296859,32.71275829524805],"zoom":11,"pitch":0,"bearing":0},{"city":"Paris","country":"France","bbox":[2.2077395643362934,48.763114319322,2.445930480937335,48.97194929141432],"center":[2.3268350226434222,48.86764074968917],"zoom":11.01,"pitch":0,"bearing":0},{"city":"Marseille","country":"France","bbox":[5.297785614843207,43.24765198198091,5.413229572354027,43.359627843308516],"center":[5.355507593561583,43.30366569397168],"zoom":11,"pitch":0,"bearing":0},{"city":"London","country":"United Kingdom","bbox":[-0.2440931367325163,51.41452029559312,-0.014090504902384282,51.605316885292524],"center":[-0.12909182082535153,51.51001847047806],"zoom":11,"pitch":0,"bearing":0},{"city":"Sydney","country":"Australia","bbox":[151.09499867334733,-33.995177344764734,151.32500130516115,-33.74063289851693],"center":[151.2099999893161,-33.86799999435354],"zoom":11,"pitch":0,"bearing":0},{"city":"Seattle","country":"United States","bbox":[-122.44510131591952,47.50034811437624,-122.21509868411596,47.70704770080869],"center":[-122.33010000000002,47.60380000000001],"zoom":11,"pitch":0,"bearing":0},{"city":"Prague","country":"Czech Republic","bbox":[14.356105218273086,50.00508018703243,14.5105128039921,50.137172043952546],"center":[14.433309011123242,50.07117159559496],"zoom":11,"pitch":0,"bearing":0},{"city":"Melbourne","country":"Australia","bbox":[144.87567365610897,-37.9195747246009,145.0302928556502,-37.75681975271668],"center":[144.9529832558478,-37.838242127295075],"zoom":11,"pitch":0,"bearing":0},{"city":"Tokyo","country":"Japan","bbox":[139.692690400186,35.59625589186878,139.84730959972887,35.76365631217948],"center":[139.76999999994655,35.68000000066236],"zoom":11,"pitch":0,"bearing":0},{"city":"Rio de Janeiro","country":"Brazil","bbox":[-43.286709581692435,-23.005880431867794,-43.132090382133896,-22.816053127725738],"center":[-43.20939998194547,-22.911000005804425],"zoom":11,"pitch":0,"bearing":0},{"city":"Cape Town","country":"South Africa","bbox":[18.36682416459732,-33.99003664855611,18.48670594183332,-33.85744989931334],"center":[18.42676505322902,-33.923769068493776],"zoom":11,"pitch":0,"bearing":0},{"city":"Dublin","country":"Ireland","bbox":[-6.318758849465809,53.30276980591222,-6.199041143979542,53.39801820502109],"center":[-6.258899996731998,53.35042060809451],"zoom":11,"pitch":0,"bearing":0},{"city":"Barcelona","country":"Spain","bbox":[2.117081147279663,41.32261000097057,2.2367988527659577,41.44233489293484],"center":[2.1769399999997177,41.382500000000476],"zoom":11,"pitch":0,"bearing":0},{"city":"Frankfurt","country":"Germany","bbox":[8.619861147269063,50.06242023664012,8.739578852755216,50.16474509756816],"center":[8.679719999996792,50.11360999999613],"zoom":11,"pitch":0,"bearing":0}],
      styles: [{"image":"/styles/black.png", "showTexture": 
      false, "pattern_url":"/patterns/classy-fabric.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0,"water_color":"rgb(0, 0, 255)","water_opacity":1,"road_color":"rgb(245, 245, 245)"},{"image":"/styles/gray.png","showTexture": false,"pattern_url":"/patterns/classy-fabric.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0,"water_color":"rgb(128, 128, 128)","water_opacity": 1,"road_color":"rgb(255, 255, 255)"},{"image":"/styles/white.png","showTexture": false,"pattern_url":"/patterns/asfalt-light.png","landscape_color":"rgb(255, 255, 255)","landscape_opacity":0,"water_color":"rgb(0, 0, 0)","water_opacity":1,"road_color":"rgb(25, 25, 25)"},{"image":"/styles/blue.png","showTexture": false,"pattern_url":"/patterns/brilliant.png","landscape_color":"rgb(0, 0, 255)","landscape_opacity":0,"water_color":"rgb(0, 0, 0)","water_opacity":1,"road_color":"white"},{"image":"/styles/red.png","showTexture": false,"pattern_url":"/patterns/diamond-eyes.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0,"water_color":"rgb(255, 0, 0)","water_opacity":1,"road_color":"white"},{"image":"/styles/pink.png","showTexture": true,"pattern_url":"/patterns/low-contrast-linen.png","landscape_color":"rgb(255, 192, 203)","landscape_opacity":0.5,"water_color":"rgb(199, 21, 133)","water_opacity":0.5,"road_color":"rgb(0, 0, 0)"},{"image":"/styles/orange.png","showTexture": true,"pattern_url":"/patterns/egg-shell.png","landscape_color":"rgb(255, 165, 0)","landscape_opacity":0.5,"water_color":"rgb(245, 0, 17)","water_opacity":0.5,"road_color":"rgb(255, 34, 34)"},{"image":"/styles/blueish.png","showTexture": true,"pattern_url":"/patterns/subtle-white-feathers.png","landscape_color":"rgba(27, 11, 147, 0.68)","landscape_opacity":0.5,"water_color":"rgba(24, 9, 107, 0.96)","water_opacity":0.5,"road_color":"white"},{"image":"/styles/green.png","showTexture": false,"pattern_url":"/patterns/brushed-alum-dark.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0,"water_color":"rgb(16, 0, 150)","water_opacity":1,"road_color":"rgb(16, 0, 150)"},{"image":"/styles/navy.png","showTexture": false,"pattern_url":"/patterns/navy.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0,"water_color":"rgb(0, 0, 0)","water_opacity":1,"road_color":"#FFFF00"},{"image":"/styles/blackwood.png","showTexture": true,"pattern_url":"/patterns/retina-wood.png","landscape_color":"rgb(0, 0, 0)","landscape_opacity":0.5,"water_color":"rgb(145, 145, 145)","water_opacity":0.5,"road_color":"white"},{"image":"/styles/concrete.png","showTexture": true,"pattern_url":"/patterns/textured-paper.png","landscape_color":"rgb(60, 33, 79)","landscape_opacity":0.5,"water_color":"rgb(24, 24, 115)","water_opacity":0.5,"road_color":"white"}]
    }
  },
  watch: {
    orientation: function(newO, oldO){
      var self = this
      self.calculateDimensions()
    },
    size: function(newS, oldS){
      var self = this
      self.calculateDimensions()
    },
    overlay: function(newO, oldO){
      var self = this
      if(newO === false){
        if(self.labels){
          if(self.overlayShape !== 'text' || self.overlayShape !== 'none'){
            self.overlayShape = 'none'
          }
        }
      }
    },
    water_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('water', 'fill-color', newColor);
      map.setPaintProperty('waterway', 'line-color', newColor);
    },
    water_opacity: function(newOpacity, oldOpacity){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('water', 'fill-opacity', parseFloat(newOpacity));
    },
    landscape_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('background', 'background-color', newColor);
      map.setPaintProperty('landuse_residential', 'fill-color', newColor);
    },
    landscape_opacity: function(newOpacity, oldOpacity){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('background', 'background-opacity', parseFloat(newOpacity));
    },
    road_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('road-rail', 'line-color', newColor);
      map.setPaintProperty('road-motorway', 'line-color', newColor);
      map.setPaintProperty('road-primary', 'line-color', newColor);
      map.setPaintProperty('road-secondary-tertiary', 'line-color', newColor);
      map.setPaintProperty('road-street', 'line-color', newColor);
      map.setPaintProperty('road-street_limited', 'line-color', newColor);
      map.setPaintProperty('road-service-link-track', 'line-color', newColor);
      map.setPaintProperty('road-pedestrian', 'line-color', newColor);
      map.setPaintProperty('road-motorway_link', 'line-color', newColor);
      map.setPaintProperty('road-trunk', 'line-color', newColor);
      map.setPaintProperty('road-trunk_link', 'line-color', newColor);
      map.setPaintProperty('road-steps', 'line-color', newColor);
      map.setPaintProperty('road-path', 'line-color', newColor);
      map.setPaintProperty('road-sidewalks', 'line-color', newColor);
      map.setPaintProperty('road-construction', 'line-color', newColor);
      map.setPaintProperty('road-street_limited-low', 'line-color', newColor);
      map.setPaintProperty('road-street-low', 'line-color', newColor);

      map.setPaintProperty('tunnel-motorway', 'line-color', newColor);
      map.setPaintProperty('tunnel-trunk', 'line-color', newColor);
      map.setPaintProperty('tunnel-primary', 'line-color', newColor);
      map.setPaintProperty('tunnel-secondary-tertiary', 'line-color', newColor);
      map.setPaintProperty('tunnel-street', 'line-color', newColor);
      map.setPaintProperty('tunnel-street_limited', 'line-color', newColor);
      map.setPaintProperty('tunnel-service-link-track', 'line-color', newColor);
      map.setPaintProperty('tunnel-pedestrian', 'line-color', newColor);
      map.setPaintProperty('tunnel-motorway_link', 'line-color', newColor);
      map.setPaintProperty('tunnel-trunk_link', 'line-color', newColor);
      map.setPaintProperty('tunnel-steps', 'line-color', newColor);
      map.setPaintProperty('tunnel-path', 'line-color', newColor);
      map.setPaintProperty('tunnel-construction', 'line-color', newColor);
      map.setPaintProperty('tunnel-street_limited-low', 'line-color', newColor);
      map.setPaintProperty('tunnel-street-low', 'line-color', newColor);

      map.setPaintProperty('aeroway-taxiway', 'line-color', newColor);
      map.setPaintProperty('aeroway-runway', 'line-color', newColor);
      map.setPaintProperty('aeroway-polygon', 'fill-color', newColor);

      map.setPaintProperty('bridge-motorway-2', 'line-color', newColor);
      map.setPaintProperty('bridge-trunk-2', 'line-color', newColor);
      map.setPaintProperty('bridge-motorway_link-2', 'line-color', newColor);
      map.setPaintProperty('bridge-trunk_link-2', 'line-color', newColor);
      map.setPaintProperty('bridge-rail', 'line-color', newColor);
      map.setPaintProperty('bridge-motorway', 'line-color', newColor);
      map.setPaintProperty('bridge-trunk', 'line-color', newColor);
      map.setPaintProperty('bridge-primary', 'line-color', newColor);
      map.setPaintProperty('bridge-secondary-tertiary', 'line-color', newColor);
      map.setPaintProperty('bridge-street', 'line-color', newColor);
      map.setPaintProperty('bridge-street_limited', 'line-color', newColor);
      map.setPaintProperty('bridge-service-link-track', 'line-color', newColor);
      map.setPaintProperty('bridge-pedestrian', 'line-color', newColor);
      map.setPaintProperty('bridge-motorway_link', 'line-color', newColor);
      map.setPaintProperty('bridge-trunk_link', 'line-color', newColor);
      map.setPaintProperty('bridge-steps', 'line-color', newColor);
      map.setPaintProperty('bridge-path', 'line-color', newColor);
      map.setPaintProperty('bridge-construction', 'line-color', newColor);
      map.setPaintProperty('bridge-street_limited-low', 'line-color', newColor);
      map.setPaintProperty('bridge-street-low', 'line-color', newColor);
/*
      map.setPaintProperty('road_trunk', 'line-color', newColor);
      map.setPaintProperty('road_primary', 'line-color', newColor);
      map.setPaintProperty('road_street_low', 'line-color', newColor);
      map.setPaintProperty('road_path', 'line-color', newColor);
      map.setPaintProperty('road_minor', 'line-color', newColor);
      map.setPaintProperty('road_trunk_primary', 'line-color', newColor);
      map.setPaintProperty('road_secondary_tertiary', 'line-color', newColor);
      map.setPaintProperty('road_major_motorway', 'line-color', newColor);
      map.setPaintProperty('highway_path', 'line-color', newColor);
      map.setPaintProperty('highway_minor', 'line-color', newColor);
      map.setPaintProperty('highway_major_casing', 'line-color', newColor);
      map.setPaintProperty('highway_major_inner', 'line-color', newColor);
      map.setPaintProperty('highway_major_subtle', 'line-color', newColor);
      map.setPaintProperty('highway_motorway_casing', 'line-color', newColor);
      map.setPaintProperty('highway_motorway_inner', 'line-color', newColor);
      map.setPaintProperty('highway_motorway_subtle', 'line-color', newColor);
      map.setPaintProperty('highway_motorway_bridge_casing', 'line-color', newColor);
      map.setPaintProperty('highway_motorway_bridge_inner', 'line-color', newColor);
      map.setPaintProperty('tunnel_motorway_casing', 'line-color', newColor);
      map.setPaintProperty('tunnel_motorway_inner', 'line-color', newColor);
      map.setPaintProperty('railway', 'line-color', newColor);
      map.setPaintProperty('railway_dashline', 'line-color', newColor);
      map.setPaintProperty('railway_transit', 'line-color', newColor);
      map.setPaintProperty('tunnel_railway_transit', 'line-color', newColor);
      map.setPaintProperty('railway_transit_dashline', 'line-color', newColor);
      map.setPaintProperty('railway_service', 'line-color', newColor);
      map.setPaintProperty('railway_service_dashline', 'line-color', newColor);
*/
    },
    building_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('building', 'fill-color', newColor);
    },
    nature_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('park', 'fill-color', newColor);      
      map.setPaintProperty('landcover_ice_shelf', 'fill-color', newColor);
      map.setPaintProperty('landcover_glacier', 'fill-color', newColor);
      map.setPaintProperty('landcover_wood', 'fill-color', newColor);
    },
    boundary_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.setPaintProperty('boundary_state', 'line-color', newColor);
      map.setPaintProperty('boundary_country', 'line-color', newColor);
      map.setPaintProperty('boundary_2', 'line-color', newColor);
      map.setPaintProperty('boundary_3', 'line-color', newColor);
      map.setPaintProperty('admin_sub', 'line-color', newColor);
      map.setPaintProperty('admin_country', 'line-color', newColor);
    },
    label_color: function(newColor, oldColor){
      var self = this
      var map = self.$refs.mapbox._map

      map.style.stylesheet.layers.forEach(function(layer) {
        if(layer.type === 'symbol'){
          map.setPaintProperty(layer.id, 'text-color', newColor);
        }
      })
    }
  },
  computed: {
    isCollapsed: function(){
        var self = this
        if(self.ui.windowWidth < 964 || self.orientation === 'horizontal'){
          self.ui.drawerActive = true
          return true
        } else {
          self.ui.drawerActive = false
          return false
        }
    },
    isMobileWidth: function () {
      return this.ui.windowWidth <= 600
    },
    showFreeShipping: function() {
      var self = this
      if((self.ui.windowWidth > 964 && self.ui.windowWidth < 1150) && self.orientation !== 'horizontal'){
        return false
      } else {
        return true
      }
    },
    maxHeightAdjustment: function() {
        var self = this
        var h = Math.max(document.documentElement.clientHeight, window.outerHeight || 0)
        var w = Math.max(document.documentElement.clientWidth, window.outerWidth || 0)
        var vh = (90 * h) / 100 - 94 - 45
        var vw = (90 * w) / 100
        return vh
    },
    centeredAdjustment: function() {
        var self = this
        var innerWidth = window.innerWidth
        var centered = (innerWidth - self.mapWidth - 30)/2
        if(self.isCollapsed === false){
          return 'auto'
        } else {
          return centered + 'px'
        }
    },
    iconTransform: function(){
      var self = this
      var icon = {}

      if(self.overlayShape === 'heart'){
        icon.width = 52
        icon.height = 48.34
      }
      if(self.overlayShape === 'smile'){
        icon.width = 493.22
        icon.height = 493.22
      }
      if(self.overlayShape === 'circle'){
        icon.width = 438.533
        icon.height = 438.533
      }
      if(self.overlayShape === 'square'){
        icon.width = 16
        icon.height = 16
      }
      var borderHeightScale = Math.min(self.percentage(self.mapHeight, 13.333), 100)
      var borderWidthScale = Math.min(self.percentage(self.mapHeight, 9.756), 100)
      var scale = self.orientation === 'horizontal' ? ((self.mapHeight - borderHeightScale) / icon.height) : ((self.mapWidth - borderWidthScale) / icon.width)
      var translateX = (self.mapWidth - (icon.width*scale))/2
      var translateY = (self.mapHeight - (icon.height*scale))/2
      var transform = {transform: 'translate(' + translateX + 'px,' + translateY + 'px) scale(' + scale + ')'}

      return transform
    },
    price: function(){
      var self = this
      var price = 49

      if(self.finish === 'framed'){
        price = price + 30
      }
      if(self.size === '18x18'){
        price = price + 35
      }
      if(self.size === '18x24'){
        price = price + 40
      }
      return price
    },
    city: function(){
      var self = this
      return {city: self.text, country: self.subtitle, bbox: self.bbox, center: self.center, zoom: self.zoom, pitch: self.pitch, bearing: self.bearing}
    },
    currentPattern: function(){
      var self = this
      return {image: '', pattern_url: self.pattern_url, landscape_color: self.landscape_color, water_color: self.water_color, road_color: self.road_color}
    },
    sampledCities () {
      var self = this
      return sampleSize(self.cities, 3)
    },
    computedPattern () {
      var self = this
      // return self.patternURL(self.pattern_url)
      if (self.showTexture) {
        return "url('//instantly-art.firebaseapp.com/static"+self.pattern_url+"')"
      } else {
        return "none"
      }
    },
    textOptions: function () {
      var self = this
      var y = self.mapHeight !== null ? self.mapHeight : 0
      /*
      if(self.finish === 'framed'){
        var y = self.mapHeight !== null ? (self.mapHeight) - Math.min(self.percentage(self.mapHeight, 2.142), 15) : 0
      }
      */


      var titleOptions = {y: 0}
      var subtitleOptions = {y: 0}
      var taglineOptions = {y: 0}
      
      var isTitle = self.text.length > 0
      var isSubtitle = self.subtitle.length > 0 && self.showSubtitle
      var isTagline = self.tagline.length > 0 && self.showTagline
      
      if(isSubtitle && !isTagline){
        titleOptions.y = y - Math.min(self.percentage(self.mapHeight, 2.857), 20)
        subtitleOptions.y = y + Math.min(self.percentage(self.mapHeight, 1.428), 10)
      }
      if(isSubtitle && isTagline){
        titleOptions.y = y - Math.min(self.percentage(self.mapHeight, 3.571), 25)
        subtitleOptions.y = y 
        taglineOptions.y = y + Math.min(self.percentage(self.mapHeight, 2.857), 20)
      }
      if(!isSubtitle && isTagline){
        titleOptions.y = y - Math.min(self.percentage(self.mapHeight, 2.857), 20)
        taglineOptions.y = y + Math.min(self.percentage(self.mapHeight, 1.428), 10)
      }
      if(!isSubtitle && !isTagline){
        if(self.overlayShape === 'none'){
          //titleOptions.y = y + Math.min(self.percentage(self.mapHeight, 0.714), 5)
          //titleOptions.y = y + (Math.min(10, self.percentage(self.mapHeight, 10)/2))
          titleOptions.y = y
        } else {
          titleOptions.y = y
          //titleOptions.y = y + (Math.min(10, self.percentage(self.mapHeight, 10)/2))
          //titleOptions.y = y + Math.min(self.percentage(self.mapHeight, 0.714), 5)
        }
      }
      // percentage based off of 675 
      var scaleParent = self.mapWidth < self.mapHeight ? self.mapWidth : self.mapHeight
      if(self.text.length <= 13){
        var titleFontSize = Math.min(self.percentage(scaleParent, 0.785), 5.4) * self.title_font_scale + 'em'
      } else if(self.text.length > 13 && self.text.length < 16){
        var titleFontSize = Math.min(self.percentage(scaleParent, 0.666), 4.5) * self.title_font_scale + 'em'
      } else if (self.text.length > 15 && self.text.length < 18) {
        var titleFontSize = Math.min(self.percentage(scaleParent, 0.592), 4) * self.title_font_scale + 'em'
      } else {
        var titleFontSize = Math.min(self.percentage(scaleParent, 0.370), 2.5) * self.title_font_scale + 'em'
      }

      if(self.overlayShape){}

      //var titleFontSize = Math.min(self.percentage(self.mapHeight, 0.357), 2.5) + 'em'
      var subtitleFontSize = Math.min(self.percentage(scaleParent, 0.222), 1.5) + 'em'
      var taglineFontSize = Math.min(self.percentage(scaleParent, 0.148), 1) + 'em'


      self.$nextTick(function(){
        
        self.calculateTextBGHeight()

/*
        if(document.getElementById('text-group') !== null){
          var text_group = document.getElementById('text-group').getBBox()
          //var text_background = self.mapHeight - text_group.height - 5
          var text_background = self.mapHeight - group_height
        } else {
          var text_background = self.mapHeight - Math.min(100, self.percentage(self.mapHeight, 15))
          var text_group = {y: 0}
          var text_rects = {y: 0}
        }
        var isSubtitle = self.subtitle.length > 0
        var isTagline = self.tagline.length > 0
        var adjustment = 5
        var text_group_height = -15
        if(isSubtitle && isTagline){
          adjustment = (5/self.title_font_scale)
          self.text_group_height = -((text_group.height / 4) + adjustment)
        }
        if(!isSubtitle && !isTagline){
          adjustment = 0
          text_group_height = -15
        }

        */

        var isSubtitle = self.subtitle.length > 0 && self.showSubtitle
        var isTagline = self.tagline.length > 0 && self.showTagline
        //var scaleParent = self.mapWidth > self.mapHeight ? self.mapWidth : self.mapHeight
        var scaleParent = self.mapHeight
        var isMobile = self.mapWidth < 400
        var mobileAdjustment = self.orientation === 'horizontal' ? 10 : 22.5
        if(self.overlayShape === 'none'){
          if(isSubtitle && isTagline){
            if(isMobile){
              self.text_group_height = -(Math.min(self.percentage(scaleParent, 10), mobileAdjustment))
            } else {
              self.text_group_height = -35
            }
          } else if(!isSubtitle && isTagline){
             if(isMobile){
              self.text_group_height = -20
            } else {
              self.text_group_height = -25
            }
          } else if(isSubtitle && !isTagline){
            if(isMobile){
              self.text_group_height = -15
            } else {
              self.text_group_height = -25
            }
          } else {
            if(isMobile){
              self.text_group_height = -10
            } else {
              self.text_group_height = -15
            }
          }
        } else {
          //self.text_group_height = -((text_group.height / 4) + adjustment)
          var heights = self.calculateTextBGHeight()
          if(isSubtitle && isTagline){
            if(isMobile){
              //self.text_group_height = -(Math.min(self.percentage(scaleParent, 10), mobileAdjustment))
              self.text_group_height = -20
            } else {
              self.text_group_height = -35
            }
          } else if(!isSubtitle && isTagline){
            if(isMobile){
              self.text_group_height = -20
            } else {
              self.text_group_height = -25
            }
          } else if(isSubtitle && !isTagline){
            if(isMobile){
              self.text_group_height = -15
            } else {
              self.text_group_height = -25
            }
          } else {
            if(isMobile){
              self.text_group_height = -10
            } else {
              self.text_group_height = -15
            }
          }
        }
      })

      return {title: titleOptions, subtitle: subtitleOptions, tagline: taglineOptions, titleFontSize: titleFontSize, subtitleFontSize: subtitleFontSize, taglineFontSize: taglineFontSize}
    },
    mapStyle: function(){
      //return 'https://maps.tilehosting.com/styles/' + this.style + '/style.json?key=OIFEoWXHvipsS8gseaPo'
      //return 'mapbox://styles/generative/cjj2nqy1m2lgd2rqoxipzeul8'
      //return 'mapbox://styles/generative/cjj5dzn2a0fkm2ss8glul0x13'

      return 'mapbox://styles/generative/cjj2fqpo92dlx2sprw2gw5hr1'      
      //return 'https://maps.tilehosting.com/c/bfe283fa-c6f5-41e5-8ba9-f1648cacf746/styles/basic-e9565/style.json?key=OIFEoWXHvipsS8gseaPo'
    },
    dimensions: function(){
      var self = this

      var mapDimensions = {}

      if(self.size === '12x18'){
        mapDimensions = {width: 1500, height: 2250}
      }
      if(self.size === '18x24'){
        mapDimensions = {width: 1800, height: 2400}
      }
      if(self.size === '24x36'){
        mapDimensions = {width: 3000, height: 4500}
      }

      if(document.getElementById('map-container') !== null){
        var containerDimensions = document.getElementById('map-container').getBoundingClientRect() 
      } else {
        var containerDimensions = {width: 400, height: 600}
      }
      
      var ratio = Math.min(containerDimensions.width / mapDimensions.width, containerDimensions.height / mapDimensions.height);
      var width = self.orientation === 'vertical' ?  mapDimensions.width*ratio : mapDimensions.height*ratio
      var height = self.orientation === 'vertical' ?  mapDimensions.height*ratio :  mapDimensions.width*ratio

      return { width: width, height: height };
    }
  },
  methods: {
    calculateTextBGHeight: function(){
      var self = this

      var textMeasurer = new TextMeasurer()
      var group_height = 0
      var heights = {title: 0, subtitle: 0, tagline: 0}
        
      if(document.getElementById('title') !== null && self.text.length > 0){
        var title_font_size = window.getComputedStyle(document.getElementById("title")).fontSize
        var title_size = textMeasurer.measureText({ 
          text: self.text, 
          fontSize: title_font_size, 
          fontWeight: 'normal', 
          fontFamily: self.font_family 
        })
        heights.title = title_size.height
      }

      if(document.getElementById('subtitle') !== null && self.subtitle.length > 0){
        var subtitle_font_size = window.getComputedStyle(document.getElementById("subtitle")).fontSize
        var subtitle_size = textMeasurer.measureText({ 
          text: self.subtitle, 
          fontSize: subtitle_font_size, 
          fontWeight: 'normal', 
          fontFamily: self.font_family 
        })
        heights.subtitle = subtitle_size.height
      }
      if(document.getElementById('tagline') !== null && self.tagline.length > 0){
        var tagline_font_size = window.getComputedStyle(document.getElementById("tagline")).fontSize
        var tagline_size = textMeasurer.measureText({ 
          text: self.tagline, 
          fontSize: tagline_font_size, 
          fontWeight: 'normal', 
          fontFamily: self.font_family 
        })
        heights.tagline = tagline_size.height
      }

      var isTitle = self.text.length > 0
      var isSubtitle = self.subtitle.length > 0 && self.showSubtitle
      var isTagline = self.tagline.length > 0 && self.showTagline

      var scaleParent = self.mapHeight
      var isMobile = self.mapWidth < 400
      var mobileAdjustment = self.orientation === 'horizontal' ? 15 : 30

      if(isSubtitle && isTagline){
        if(isMobile){
          group_height = (title_size.height + subtitle_size.height + tagline_size.height) + (Math.min(self.percentage(scaleParent, 10), mobileAdjustment))
        } else {
          group_height = (title_size.height + subtitle_size.height + tagline_size.height) + 40
        }
      } else if(isSubtitle && !isTagline){
        if(isMobile){
          group_height = (title_size.height + subtitle_size.height) + (Math.min(self.percentage(scaleParent, 10), mobileAdjustment))
        } else {
          group_height = (title_size.height + subtitle_size.height) + 40
        }
      } else if(!isSubtitle && isTagline){
        if(isMobile){
          group_height = (title_size.height + tagline_size.height) + (Math.min(self.percentage(scaleParent, 10), mobileAdjustment))
        } else {
          group_height = (title_size.height + tagline_size.height) + 40
        }
      } else {
        if(isTitle){
          if(isMobile){
            group_height = (title_size.height) + 20
          } else {
            group_height = (title_size.height) + 30
          }
        }
      }

      if(self.finish === 'framed'){
        //group_height = group_height + 15
      }

      self.bg_height = self.mapHeight - group_height
      //console.log(group_height)
      return heights
    },
    autoCompleteSearch: function(query){
      var self = this
      var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + query + '.json?access_token=pk.eyJ1IjoiZ2VuZXJhdGl2ZSIsImEiOiJjamd5ajB4OHEyZXVoMnFwMXB1ZTl0ZTFtIn0.kCqRJ5JJUmhjmftGHaYZoA&types=place&autocomplete=true&limit=5&language=en'
      
      return new Promise((resolve, reject) => {
        fetch(url).then(response => {
          if (!response.ok) {
            reject()
          }
          response.json().then(json => {
            let places = json.features
            //console.log(json)
            let results = []
            let suggestions = []
            places.forEach((loc, i) => {
              var result = {text: loc.place_name, place: loc.text, country: '', bbox: loc.bbox, center: loc.center}

              loc.context.forEach((context, i) => {
                if(context.id.indexOf('country') >= 0){
                  result.country = context.text
                  return
                }
              })              
              if(result.country !== ''){
                suggestions.push(result)
                results.push(loc.place_name)
              }
            })
            //console.log(results)
            self.suggestions = suggestions
            resolve(results)
          }).catch(e => {
            console.log(e)
            reject(e)
          })
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    autoGoToLocation: function(query){
      var self = this
      var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + query + '.json?access_token=pk.eyJ1IjoiZ2VuZXJhdGl2ZSIsImEiOiJjamd5ajB4OHEyZXVoMnFwMXB1ZTl0ZTFtIn0.kCqRJ5JJUmhjmftGHaYZoA&types=place&autocomplete=true&limit=5&language=en'
      
      return new Promise((resolve, reject) => {
        fetch(url).then(response => {
          if (!response.ok) {
            reject()
          }
          response.json().then(json => {
            let places = json.features
            //console.log(json)
            let results = []
            let suggestions = []
            places.forEach((loc, i) => {
              var result = {text: loc.place_name, place: loc.text, country: '', bbox: loc.bbox, center: loc.center}

              loc.context.forEach((context, i) => {
                if(context.id.indexOf('country') >= 0){
                  result.country = context.text
                  return
                }
              })              
              if(result.country !== ''){
                suggestions.push(result)
                results.push(loc.place_name)
              }
            })

            if (suggestions.length > 0) {
              var place = suggestions[0]
              self.bbox = place.bbox
              self.center = place.center
              self.text = place.place.toUpperCase()
              if(self.subtitle !== ''){
                self.subtitle = place.country.toUpperCase()
              }
              if(self.tagline !== ''){
                var direction1 = self.center[1] > 0 ? 'N' : 'S'
                var direction2 = self.center[0] < 0 ? 'W' : 'E'
                self.tagline = self.center[1].toFixed(2) + '°' + direction1 + ' / ' + self.center[0].toFixed(2) + '°' + direction2
              }
              self.$refs.mapbox._map.flyTo({center: self.center, zoom: self.zoom})
              if(self.isCollapsed === true){
                self.$refs.mapbox._map.jumpTo({center: self.center, zoom: self.zoom})
                self.closeAccordion()
              } else {
                self.$refs.mapbox._map.flyTo({center: self.center, zoom: self.zoom})
              }

              resolve(place)

            } else {

              self.jumpToCity('random')
              resolve()
            }
          }).catch(e => {
            console.log(e)
            reject(e)
          })
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    goToLocation: function(place){
      var self = this
      if(place !== null){
        place = self.suggestions.find((obj) => { return obj.text === place })
        self.bbox = place.bbox
        self.center = place.center
        self.text = place.place.toUpperCase()
        if(self.subtitle !== ''){
          self.subtitle = place.country.toUpperCase()
        }
        if(self.tagline !== ''){
          var direction1 = self.center[1] > 0 ? 'N' : 'S'
          var direction2 = self.center[0] < 0 ? 'W' : 'E'
          self.tagline = self.center[1].toFixed(2) + '°' + direction1 + ' / ' + self.center[0].toFixed(2) + '°' + direction2
        }
        self.$refs.mapbox._map.flyTo({center: self.center, zoom: self.zoom})
        if(self.isCollapsed === true){
          self.$refs.mapbox._map.jumpTo({center: self.center, zoom: self.zoom})
          if (self.ui.currentAccordion !== '') {
            self.closeAccordion()
          }
        } else {
          self.$refs.mapbox._map.flyTo({center: self.center, zoom: self.zoom})
        }

        self.gaEvent('locationSearch', self.text)
      }
    },
    clearSuggestions: function(){
      var self = this
      self.$refs.suggestComponent.clearSuggestions()
      self.search = ''
      self.suggestions = []
    },
    mapInitialized: function(map){
      var attribution = new mapboxgl.AttributionControl({
        compact: true
      })
      map.addControl(attribution)
    },
    mapLoaded: function(map){
      var self = this
      var bounds = ''

      document.getElementsByClassName('mapboxgl-ctrl-logo')[0].style.visibility = 'hidden';
      document.getElementsByClassName("mapbox-improve-map")[0].parentNode.removeChild(document.getElementsByClassName("mapbox-improve-map")[0])
      self.toggleText()
      //self.water_color = '#FFFFFF'
      //self.landscape_color = '#000000'
      //self.road_color = '#FFFFFF'
      

      bounds = map.getBounds().toArray()
      self.bbox = [bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]]
      self.center = [map.getCenter().lng, map.getCenter().lat]
      self.zoom = map.getZoom()
      self.pitch = map.getPitch()
      self.bearing = map.getBearing()

     
      map.fitBounds([[-74.03762409615973,40.68374386217124], [-73.90429493977683,40.81836755031753]])
      map.setPitch(self.pitch)
      map.setBearing(self.bearing)
      map.style.stylesheet.transition = {
        duration: 0,
        delay: 0
      }

      var direction1 = self.center[1] > 0 ? 'N' : 'S'
      var direction2 = self.center[0] < 0 ? 'W' : 'E'
      self.tagline = self.center[1].toFixed(2) + '°' + direction1 + ' / ' + self.center[0].toFixed(2) + '°' + direction2
      
      self.setStyle(self.styles[0])
      self.loadSettings()

/*
      map.style.stylesheet.layers.forEach(function(layer) {
        console.log(layer.id, layer.type)
        if(layer.type === 'symbol'){
          console.log(layer)
        }
      })
*/            
    },
    mapMoveEnd: function(map){
      var self = this
      var bounds = ''
      bounds = map.getBounds().toArray()
      self.bbox = [bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]]
      self.center = [map.getCenter().lng, map.getCenter().lat]
      self.zoom = map.getZoom()
      self.pitch = map.getPitch()
      self.bearing = map.getBearing()
      //console.log(self.bbox)
      //console.log(self.center, self.zoom, self.pitch, self.bearing)

      if(self.tagline !== ''){
        var direction1 = self.center[1] > 0 ? 'N' : 'S'
        var direction2 = self.center[0] < 0 ? 'W' : 'E'
        self.tagline = self.center[1].toFixed(2) + '°' + direction1 + ' / ' + self.center[0].toFixed(2) + '°' + direction2
      }
    },
    mapResize: function(map){
      var self = this
      var bounds = ''
      bounds = map.getBounds().toArray()
      self.bbox = [bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]]
      self.center = [map.getCenter().lng, map.getCenter().lat]
      self.zoom = map.getZoom()
      self.pitch = map.getPitch()
      self.bearing = map.getBearing()
    },
    setCoordinates: function(map){
      var self = this
    },
    onResize: function(){
      var self = this
      var map = self.$refs.mapbox._map
      self.calculateDimensions()
      map.resize()
      //console.log('resized')
      map.setZoom(Math.max(Math.min(self.percentage(self.mapHeight, 1.316), 11), 11.01))
    },
    onLocation: function(){
      var self = this

    },
    styleChange: function(){
      var self = this
      var style = ''
      style = self.style === 'red-map' ? 'https://maps.tilehosting.com/c/bfe283fa-c6f5-41e5-8ba9-f1648cacf746/styles/red-map/style.json?key=OIFEoWXHvipsS8gseaPo' : self.mapStyle
      self.$refs.mapbox._map.setStyle(style)
    },
    toggleText: function(){
      var self = this

      var map = self.$refs.mapbox._map

      map.style.stylesheet.layers.forEach(function(layer) {
        if (layer.type === 'symbol') {
          var visibility = map.getLayoutProperty(layer.id, 'visibility');
          if (visibility === 'visible') {
            map.setLayoutProperty(layer.id, 'visibility', 'none');
          } else {
            map.setLayoutProperty(layer.id, 'visibility', 'visible');
          }
          // map.removeLayer(layer.id)
        }
      })
    },
    toggleOrientation: function(){
      var self = this

      if(self.oritentation === 'horizontal'){
        self.orientation = 'vertical'
      } else {
        self.orientation = 'horizontal'
      }
    },
    calculateDimensions: function(){
      var self = this

      var mapDimensions = {}

      if(self.size === '12x18'){
        mapDimensions = {width: 1500, height: 2250}
      }
      if(self.size === '18x24'){
        mapDimensions = {width: 2250, height: 3000}
      }
      if(self.size === '18x18'){
        mapDimensions = {width: 2250, height: 2250}
      }
      if(self.size === '24x36'){
        mapDimensions = {width: 3000, height: 4500}
      }

       var h = Math.max(document.documentElement.clientHeight, window.outerHeight || 0)
       var w = Math.max(document.documentElement.clientWidth, window.outerWidth || 0)
       var vh = (90 * h) / 100
       var vw = (90 * w) / 100

      if(document.getElementById('map-container') !== null){
        var containerDimensions = document.getElementById('map-container').getBoundingClientRect()

        if(containerDimensions.width > 100){
          if(self.orientation === 'vertical'){
            containerDimensions.width = containerDimensions.width
            containerDimensions.height = window.innerHeight - 94 - 15 - 54
          } else {
            containerDimensions.width = containerDimensions.width
            containerDimensions.height = window.innerHeight - 94 - 15 - 54
          }
          
          var ratioVertical = Math.min(containerDimensions.width / mapDimensions.width, containerDimensions.height / mapDimensions.height)
          var ratioHorizontal = Math.min(containerDimensions.width / mapDimensions.height, containerDimensions.height / mapDimensions.width)
          var ratio = self.orientation === 'vertical' ? ratioVertical : ratioHorizontal
          self.ratio = ratio
          self.mapWidth = self.orientation === 'vertical' ? (mapDimensions.width*ratio)-30 : (mapDimensions.height*ratio)-30
          self.mapHeight = self.orientation === 'vertical' ? (mapDimensions.height*ratio)-15 : (mapDimensions.width*ratio)-15
        } else {
          containerDimensions.width = containerDimensions.width
          //containerDimensions.height =  self.orientation === 'vertical' ? vh - 94 : vh - 94
          var ratioVertical = Math.min(containerDimensions.width / mapDimensions.width, containerDimensions.height / mapDimensions.height)
          var ratioHorizontal = Math.min(containerDimensions.width / mapDimensions.height, containerDimensions.height / mapDimensions.width)
          var ratio = self.orientation === 'vertical' ? ratioVertical : ratioHorizontal
          self.ratio = ratio
          self.mapWidth = self.orientation === 'vertical' ? (mapDimensions.width*ratio)-30 : (mapDimensions.height*ratio)-30
          self.mapHeight = self.orientation === 'vertical' ? (mapDimensions.height*ratio)-15 : (mapDimensions.width*ratio)-15

        }
      } else {
        var containerDimensions = {width: 400, height: 600}
      }
      //console.log(containerDimensions)
      //console.log(self.orientation, self.mapWidth, self.mapHeight)
    },
    patternURL: function(pattern){
      var p = "url('"+pattern+"')"
      //console.log(p)
      return "url('"+pattern+"')"
    },
    jumpToCity: function(sampledCity){
      var self = this
      var map = self.$refs.mapbox._map
      if(sampledCity === 'random'){
        var city = self.cities[random(0, self.cities.length-1)]
      } else {
        city = sampledCity
      }

      self.bbox = city.bbox
      self.center = city.center
      self.zoom = city.zoom
      self.pitch = city.pitch
      self.bearing = city.bearing
      self.text = city.city.toUpperCase()
      if(self.subtitle !== ''){
        self.subtitle = city.country.toUpperCase()
      }
      if(self.tagline !== ''){
        var direction1 = self.center[1] > 0 ? 'N' : 'S'
        var direction2 = self.center[0] < 0 ? 'W' : 'E'
        self.tagline = self.center[1].toFixed(2) + '°' + direction1 + ' / ' + self.center[0].toFixed(2) + '°' + direction2
      }

      map.jumpTo({center: self.center, zoom: self.zoom, bearing: self.bearing, pitch: self.pitch})
    },
    setStyle: function(style){
      var self = this
      self.pattern_url = style.pattern_url
      self.landscape_color = tinycolor(style.landscape_color).toHexString()
      self.water_color = tinycolor(style.water_color).toHexString()
      self.water_opacity = style.water_opacity
      self.road_color = tinycolor(style.road_color).toHexString()
      self.showTexture = style.showTexture
    },
    randomize: function(){
      var self = this

      var material = ['black', 'white', 'rgb(244, 67, 54)', 'rgb(233, 30, 99)', 'rgb(156, 39, 176)', 'rgb(103, 58, 183)', 'rgb(63, 81, 181)', 'rgb(33, 150, 243)', 'rgb(3, 169, 244)', 'rgb(0, 188, 212)', 'rgb(0, 150, 136)', 'rgb(76, 175, 80)', 'rgb(139, 195, 74)', 'rgb(205, 220, 57)', 'rgb(255, 193, 7)', 'rgb(255, 152, 0)', 'rgb(255, 87, 34)', 'rgb(121, 85, 72)', 'rgb(158, 158, 158)', 'rgb(96, 125, 139)']

      var colors = tinycolor(material[random(0, material.length)]).splitcomplement()
      colors = colors.map(function(c) { return c.toHexString() })

      self.landscape_color = colors[0]
      self.water_color = colors[1]

      self.road_color = tinycolor.readability(colors[0], colors[1]) > 1.75 ? colors[1] : (tinycolor(colors[0]).isDark() ? '#FFFFFF' : '#000000')

      var random_pattern = random(0, self.patterns.length)
      self.pattern_url = self.patterns[random_pattern]
    },
    percentage(n, percent){
      return (percent / 100) * n
    },
    closeAccordion: function() {
      var self = this
      self.$refs[self.ui.currentAccordion].show = false
    },
    setCurrentAccordion: function(state, collapse){
      var self = this
      if(state === 'hide'){
        self.ui.currentAccordion = ''
      }
      if(state === 'show'){
        self.$nextTick(function(){
          self.ui.currentAccordion = collapse
        })
      }
    },
    addToCartEvent: function(){
      var self = this
      try {
        var params = (new URL(document.location)).searchParams
        var admin = params.get("admin-style")
        if (admin === null) {
          fbq('track', 'AddToCart')
          ga('send', 'event', 'AddToCart', 'City Map', null)
        }
      }
      catch (e) {
        console.error(e)
      }
    },
    gaEvent: function (eventAction, eventLabel){
      try {
        var params = (new URL(document.location)).searchParams
        var admin = params.get("admin-style")
        if (admin === null) {
          var eAction = {}
          eAction[eventAction] = eventLabel
          fbq('trackCustom', 'City Map', eAction)
          ga('send', 'event', 'City Map', eventAction, eventLabel)
        }
      }
      catch (e) {
        console.error(e)
      }
    },
    checkout: function(){
      var self = this

      var settings = {
        bbox: self.bbox,
        center: self.center,
        zoom: self.zoom,
        pitch: self.pitch,
        bearing: self.bearing,
        landscape_color: self.landscape_color,
        landscape_opacity: self.landscape_opacity,
        water_color: self.water_color,
        water_opacity: self.water_opacity,
        road_color: self.road_color,
        showTexture: self.showTexture,
        pattern_url: self.pattern_url,
        labels: self.labels,
        title: self.text,
        subtitle: self.subtitle,
        showSubtitle: self.showSubtitle,
        tagline: self.tagline,
        showTagline: self.showTagline,
        text_spacing: self.text_spacing,
        text_layout: self.text_layout,
        text_color: self.text_color,
        text_group_height: self.text_group_height,
        text_spacing: self.text_spacing,
        title_font_scale: self.title_font_scale,
        font_family: self.font_family,
        font_src: self.font_src,
        overlay: self.overlay,
        overlayShape: self.overlayShape,
        bg_color: self.bg_color,
        bg_height: self.bg_height,
        bg_opacity: self.bg_opacity,
        finish: self.finish,
        size: self.size,
        orientation: self.orientation,
        ratio: self.ratio,
        width: self.mapWidth,
        height: self.mapHeight,
        timestamp: new Date().valueOf(),
        admin: false
      }

      var params = (new URL(document.location)).searchParams
      var admin = params.get("admin-style")
      if(admin){
        settings.admin = true
      }

      var variants = {
        'paper 12x18': 13015513497659,
        'framed 12x18': 13015512186939,
        'paper 18x18': 12936065712187,
        'framed 18x18': 12942194540603,
        'paper 18x24': 12936186069051,
        'framed 18x24': 12942194901051
      }
      //var base64 = btoa(JSON.stringify(settings))
      //console.log(settings)

      var styleid = generateID('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 12)

      db.collection('city-styles').doc(styleid).set(settings).then(() => {
        console.log('The style id for your custom city map is', styleid)

        if(!settings.admin){
          axios.post('https://instantlyart.com/cart/add.js', {
            quantity: 1,
            id: variants[settings.finish + ' ' + settings.size],
            properties: {'style': styleid}
          })
          .then((response) => {
            console.log(response)
            self.addToCartEvent()
            // window.location.href = 'https://instantlyart.com/checkout'
            self.cart()
          })
          .catch((err) => {
            console.log(err)
          })
        } else {
          self.ui.admin_message = styleid
        }

      }).catch((err) => {
        console.log('There was an error saving your style.')
      })
      

      /*
      axios.get('https://instantly-art.myshopify.com/cart.js')
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.log(error)
      })
      */
          

    },
    loadSettings: function(){
      var self = this
      var map = self.$refs.mapbox._map

      let params = (new URL(document.location)).searchParams
      let style = params.get("style")
      if(style){
        try {
          
          db.collection("city-styles").doc(style).get().then((doc) =>{
            if(doc.exists){

              let settings = doc.data()

              self.bbox = settings.bbox
              self.center = settings.center
              self.zoom = settings.zoom
              self.pitch = settings.pitch
              self.bearing = settings.bearing
              self.landscape_color = settings.landscape_color
              self.landscape_opacity = settings.landscape_opacity
              self.water_color = settings.water_color
              self.water_opacity = settings.water_opacity
              self.road_color = settings.road_color
              self.pattern_url = settings.pattern_url
              self.labels = settings.labels
              self.text = settings.title
              self.text_spacing = settings.text_spacing
              self.subtitle = settings.subtitle
              self.showSubtitle = settings.showSubtitle
              self.tagline = settings.tagline
              self.showTagline = settings.showTagline
              self.text_group_height = settings.text_group_height
              self.text_spacing = settings.text_spacing
              self.title_font_scale = settings.title_font_scale
              self.text_layout = settings.text_layout
              self.text_color = settings.text_color
              self.font_family = settings.font_family
              self.font_src = settings.font_src
              self.overlay = settings.overlay
              self.overlayShape = settings.overlayShape
              self.bg_color = settings.bg_color
              self.bg_opacity = settings.bg_opacity
              self.bg_height = settings.bg_height

              if (settings.showTexture === undefined) {
                self.showTexture = true
              } else {
                self.showTexture = settings.showTexture
              }

              var newStyle = document.createElement('style');
              newStyle.appendChild(document.createTextNode("\
                @font-face {\
                    font-family: " + self.font_family + ";\
                    src: url('" + self.font_src + "') format('truetype');\
                }\
              "));
              document.head.appendChild(newStyle);

              map.jumpTo({center: self.center, zoom: self.zoom, bearing: self.bearing, pitch: self.pitch})

              self.$nextTick(function(){
                setTimeout(function(){
                  self.calculateTextBGHeight()
                },100)
              })

            } else {
              console.log('Sorry, the style you tried loading is invalid or does not exist.')
            }
          }).catch((err) => {
            console.log('Sorry, the style you tried loading is invalid or does not exist.')
          })
        }
        catch (e){
          console.log('Sorry, the style you tried loading is invalid or does not exist.')
        }
      }

      let location = params.get("location")
      if (location) {
        self.autoGoToLocation(location)
      }
      let preset = params.get("preset")
      if (preset) {
        try {
          self.setStyle(self.styles[parseInt(preset)])
        }
        catch (e) {
          console.error(e)
        }
      }
    },
    cart: function () {
      //this.addToCartEvent()
      this.$showPanel({
        component : 'cart',
        width: '350px',
        props: {
          //any data you want passed to your component
        }
      })
    }
  },
  mounted () {
    var self = this

    // set up our font picker
    self.font_picker = new FontPicker('AIzaSyB5nqa8XKUQbMI8Byxepn75nkhCKYRmidU', self.font_family, {limit: 100, variants: ['regular']}, function(newFont){
      // we set our new font family and font location whenever it is changed
      self.font_family = newFont.family
      var font_src = 'https://' + newFont.files.regular.split('//')[1]
      self.font_src = font_src
      self.$nextTick(function(){
        setTimeout(function(){
          self.calculateTextBGHeight()
        },100)
      })
    })

    if(self.isCollapsed === true){
      var params = (new URL(document.location)).searchParams
      var isDisplay = params.get("d")
      if (isDisplay === null) {
        setTimeout(function(){
          self.ui.currentAccordion = 'style'
          self.$refs.basics.show = true
        }, 2000)
      }
    } else {
      self.ui.currentAccordion = 'style'
      self.$refs.basics.show = true
    }

    // used to determine whether we collapse the sidebar
    self.ui.windowWidth = window.innerWidth
    window.addEventListener('resize', () => {
      self.ui.windowWidth = window.innerWidth
    })

    self.calculateDimensions()
  }
}

function TextMeasurer() {    
  this.measureText = function(options) {
    var fontSize = options.fontSize || getComputedStyle(options.element, 'font-size') || '100px';
    var fontWeight = options.fontWeight || getComputedStyle(options.element, 'font-weight') || 'normal';
    var fontFamily = options.fontFamily || getComputedStyle(options.element, 'font-family') || 'Arial';
    var font = fontWeight + ' ' + fontSize + ' ' + fontFamily;
    
    var boundingRect = this.measureBoundingRect(options.text, font);
    
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.width = boundingRect.width;
    canvas.height = boundingRect.height * 1.2; // Bounding rect height may not be enough as fillText() will render from the baseline 
    context.font = font;
    context.fillText(options.text, 0, fontSize.replace('px', ''));
    
    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    var result = this.measure({ width: canvas.width, height: canvas.height, imageData: imageData, options: options });
    
    if (!result.foundTopText) {
      return { width: boundingRect.width, height: 0, yOffset: 0 };
    }
    
    if (!result.foundBottomText) {
      return { width: boundingRect.width, height: canvas.height - result.topTextY, yOffset: -result.topTextY };
    }
    
    return { width: boundingRect.width, height: result.bottomTextY - result.topTextY, yOffset: -result.topTextY };
  }
  
  this.measureBoundingRect = function(text, font) {
    var temporaryContainer = document.createElement('div');
    temporaryContainer.style.position = 'fixed';
    temporaryContainer.style.top = '0px';
    temporaryContainer.style.left = '0px';
    temporaryContainer.style.width = '0px';
    temporaryContainer.style.height = '0px';
    temporaryContainer.style.overflow = 'hidden';
    
    var temporaryElement = document.createElement('span');
    temporaryElement.style.font = font;
    temporaryElement.innerText = text;
    document.body.appendChild(temporaryElement);
    var bBox = temporaryElement.getBoundingClientRect();
    document.body.removeChild(temporaryElement);
    return bBox;
  }
  
  function Iterator(maxWidth, maxHeight) {
    this.x = 0;
    this.y = 0;
    this.index = 0;
    
    this.moveRight = function() {
      if (this.arePixelsToTheRight()) {
        this.x++;
        this.index += 4;
      } else {
        this.moveDown();
      }
    }
    
    this.moveDown = function() {
      this.x = 0;
      this.y++;
      this.index = this.y * maxWidth * 4;
    }
    
    this.arePixelsToTheRight = function() {
      return this.x < maxWidth - 1;
    }
    
    this.noMorePixels = function() {
      return this.index >= (maxWidth * maxHeight * 4) - 4;
    }
  }
  
  this.measure = function(parameters) {
    // Find the top and bottom of the text by finding which rows are entirely full of transparent pixels.
    // The difference between the top-most transparent row and the bottom-most transparent row is the text height.    
    var iterator = new Iterator(parameters.width, parameters.height);
    var foundTopText = false;
    var foundBottomText = false;
    var topTextY = null;
    var bottomTextY = null;
    var allPixelsInThisRowAreWhite;
    while (!iterator.noMorePixels()) {
      if (!foundTopText) {
        // We have only encounted rows that are totally white so far, as soon as we 
        // find a pixel that is not white we will count that as the top of the text
        if (isTransparent(parameters.imageData, iterator.index)) {
          iterator.moveRight();
        } else {
          topTextY = iterator.y;
          foundTopText = true;
          iterator.moveDown();
        }
      } else {
        // We are looping through the rows until we find a row which is all white, 
        // in which case we have reached the bottom of the text
        if (!iterator.arePixelsToTheRight()) {
          if (allPixelsInThisRowAreWhite) {
            bottomTextY = iterator.y;
            foundBottomText = true;
            break;
          }  
          allPixelsInThisRowAreWhite = true;
          iterator.moveDown();
        }
        if (!isTransparent(parameters.imageData, iterator.index)) {
          allPixelsInThisRowAreWhite = false;
          iterator.moveDown();
        } else {
          iterator.moveRight();
        }
      }
    }
    
    return { foundTopText: foundTopText, foundBottomText: foundBottomText, topTextY: topTextY, bottomTextY: bottomTextY };
  }
  
  function isTransparent(imageData, index) {
    return imageData.data[index + 3] === 0; // If there is zero alpha then it is transparent
  }
  
  function getComputedStyle(element, property) {
    return element ? window.getComputedStyle(element)[property] : null ;
  }
}
</script>

<style>
@import 'https://fonts.googleapis.com/css?family=Cabin:300,400,500,600,700';
body {
  background-color: #F5F5F5!important;
  font-family: 'Cabin'!important;
  overflow:overlay;
}
.container {
  margin-top:30px;
}
#map {
  transition: all 0.1s linear;
}
#map-bg {
  transition: all 0.1s linear;
}
#svg-overlay {
  transition: all 0.1s linear;
}
.mapboxgl-ctrl .mapboxgl-ctrl-group {
  z-index: 101!important;
}
.mapboxgl-ctrl .mapboxgl-ctrl-attrib .mapboxgl-compact {  
  z-index:101!important;
}
.mapboxgl-ctrl-bottom-right {
  z-index: 103!important; 
}
.mapboxgl-ctrl-top-right {
  z-index: 103!important; 
}
.border-finish {
  border: 25px solid;
  border-color: #252525;
  box-shadow: inset 0 0 10px #000000;
}
.v-model-event:hover {
  border: 1px solid #2874D5;
  background-color: #2874D5;
  color: white;
}
.vue-simple-suggest .suggest-item .text {
  display: inline-block;
  line-height: 1;
  vertical-align: text-bottom;
  overflow: hidden;
  max-width: 72%;
  text-overflow: ellipsis;
}
.vue-simple-suggest.designed .input-wrapper input {
  border-radius:0px;
}
.vue-simple-suggest .suggestions {
  background: white;
}
.vue-simple-suggest .suggest-item .text span {
  white-space: nowrap;
}
.vue-simple-suggest-enter-active.suggestions,
.vue-simple-suggest-leave-active.suggestions {
  transition: opacity .2s;
}
.vue-simple-suggest-enter.suggestions,
.vue-simple-suggest-leave-to.suggestions {
  opacity: 0 !important;
}
.simple-suggestion-mobile {
  margin-top: -100px!important;
  z-index: 10000!important;
  display: -webkit-inline-box!important;
  overflow-x: scroll!important;
  border-radius:0px!important;
}
.simple-suggestion-mobile-item {
  padding: 5px 10px!important;
  border-bottom: 1px solid #e3e3e3!important;
  border-right: 1px solid #e3e3e3!important;
}

.clear-suggestions {
    position: absolute;
    right: 0;
    margin-right: 15px;
    color: #c1c1c1;
    cursor: pointer;
    margin-top: 40px;
    font-size: 24px;
}
.search-icon {
  position: absolute;
  right: 15px;
  margin-top: 16px;
  color: #c1c1c1;
}
.text-input {
  padding: 10px;
  border: 1px solid #cde;
  border-radius: 0px;
  transition: all .1s;
}
#font-picker .dropdown-button {
  background: #fff;
  height: 46px;
  border-radius: 3px;
}
#font-picker ul {
  background: #fff;
  border: 1px solid #cde;
  box-shadow: none;
}
#font-picker .expanded {
  z-index: 101;
}
.vue-colorpicker {
  width:100%;
  background: #fff;
  border:0px!important;
  border-radius:0px!important;
  box-shadow:0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
}
.vue-colorpicker-btn {
  width:100%!important;
  border-radius: 0px;
  border: 1px solid #e2e2e2!important;
}
input[type="range"]{
  -webkit-appearance:none;
  width:100%;
  height:20px;
  background: linear-gradient(to right, rgb(212, 212, 212) 0%, rgb(182, 181, 181) 100%);
  background-size:100% 10px;
  background-position:center;
  background-repeat:no-repeat;
  overflow:hidden;
  outline: none;
  transition: all 0.1s linear;
  border-radius:0px;
}
input[type="range"]::-webkit-slider-thumb{
  -webkit-appearance:none;
  width:20px;
  height:20px;
  background:#007bff;
  position:relative;
  z-index:3;
  box-shadow:0 0 5px 0 rgba(0,0,0,0.3);
  cursor:pointer;
  border-radius:25px;
}
input[type="range"]::-webkit-slider-thumb:after{
  content:" ";
  width:100%;
  height:10px;
  position:absolute;
  z-index:1;
  right:20px;
  top:5px;
  background: #007bff;
  background: linear-gradient(to right, #f088fc 1%, #AC6CFF 70%);
  border-radius:25px;
}
.two-button-options label {
  width:50%;
}
.three-button-options label {
  width:33.3%;
}
.style-preview {
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  border-radius: 0px;
  width:50px;
  height:50px;
}
.toggle {
  position: absolute;
  right: 0;
  display: block;
  width: 40px;
  height: 20px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transform: translate3d(0, 0, 0);
  margin-top: 2px;
  margin-right: 3px;
}
.toggle:before {
  content: "";
  position: relative;
  top: 3px;
  left: 3px;
  width: 34px;
  height: 14px;
  display: block;
  background: #9A9999;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.toggle span {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  display: block;
  background: white;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(154, 153, 153, 0.5);
  transition: all 0.2s ease;
}
.toggle span:before {
  content: "";
  position: absolute;
  display: block;
  margin: -18px;
  width: 56px;
  height: 56px;
  background: rgba(79, 46, 220, 0.5);
  border-radius: 50%;
  transform: scale(0);
  opacity: 1;
  pointer-events: none;
}
.cbx:checked + .toggle:before {
  background: #947ADA;
}
.cbx:checked + .toggle span {
  background: #007bff;
  transform: translateX(20px);
  transition: all 0.2s cubic-bezier(0.8, 0.4, 0.3, 1.25), background 0.15s ease;
  box-shadow: 0 3px 8px rgba(79, 46, 220, 0.2);
}
.cbx:checked + .toggle span:before {
  transform: scale(1);
  opacity: 0;
  transition: all 0.4s ease;
}
.btn {
  box-shadow:0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  border-radius:0px!important;
}
.nav-tabs .nav-link {
  border-top-left-radius:0px;
  border-top-right-radius:0px;
  background-color:#FFFFFF;
}
.card {
  border:0px!important;
  border-radius:0px!important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
}
.nav-tabs {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
  margin-bottom:10px;
  border-bottom:0px;
}
.nav-tabs .nav-link {
  border:0px!important;
}
.nav-tabs.nav-item{
  border-right:1px solid #e3e3e3;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  background-color:#007bff;
  color:white;
  border-color:#007bff!important;
}

.bottom-drawer {
  position:absolute;
  bottom:0;
  width:100%;
  margin-bottom:48px;
  padding:0;
}
.checkout-button-fixed {
  position:fixed;
  bottom:0;
  left:0;
  width:100vw;
}
.card-body-drawer {
  max-height:0.0001vh;
  transition:all 0.2s linear;
}
.card-body-drawer-active .mx-datepicker .mx-datepicker-popup {
  margin-bottom:-175px!important;
}
.card-body-drawer .card-body {
  max-height:0.0001vh;
  transition: all 0.2s linear;
}
.card-body-drawer-active .card-body {
  max-height:35vh;
  overflow-y:overlay;
  transition: all 0.2s linear;
}
.card-body::-webkit-scrollbar { 
  display: none;
}
.button-group-drawer .btn .btn-primary .collapsed {
  background:#FFFFFF!important;
  color: #007bff!important;
}
.button-group-drawer .btn-primary {
  background:#FFFFFF!important;
  color: #007bff!important;
  padding:10px;
}
.drawer-button {
  cursor:pointer;
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -35px;
  width:35px;
  height:35px;
  background:#FFFFFF;
}
.drawer-button-out {
  fill: #000001;
  animation: noticeme 4s infinite;
}
@keyframes noticeme {
  0%   {fill: #000001;}
  50%  {fill: #c3c3c3;}
  100% {fill: #000001;}
}

.accordion-group {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgba(0, 0, 0, .12);
}
.bottom-drawer .accordion-group {
  box-shadow:none!important;
  margin-bottom:0px!important;
}
.btn-outline-primary {
  background: #FFFFFF;
}
.accordion-group .btn-outline-primary {
  box-shadow:none!important;
  border:none;
  border-left:1px solid #e3e3e3;
  border-color:#e3e3e3;  
  padding:10px;
  margin-left:0px;
}
.accordion-group .btn-outline-primary .active {
  border:none;
  border-left:1px solid #007bff;
  border-color:#007bff;
}
.accordion-group .btn-outline-primary:hover {
  border:none;
  border-left:1px solid #007bff;
  border-color:#007bff;
}
.bottom-drawer .accordion-group .btn-outline-primary {
  box-shadow:none!important;
  border:1px solid #e3e3e3;
  border-left:0px;
  border-color:#e3e3e3;  
  padding:10px;
  margin-left:0px;
}
.bottom-drawer .accordion-group .btn-outline-primary .active {
  border:1px solid #007bff;
  border-color:#007bff;
}
.bottom-drawer .accordion-group .btn-outline-primary:hover {
  border:1px solid #007bff;
  border-color:#007bff;
}
.card-max-height {
  max-height:75vh;
  overflow:overlay;
}
.modal-content {
  border-radius:0px!important;
}

</style>



// WEBPACK FOOTER //
// src/views/map/map.vue